function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{clip-path:url(#clip-path);}.cls-2{fill:none;}.cls-3{isolation:isolate;}.cls-4{fill:#fff;}.cls-5{clip-path:url(#clip-path-2);}.cls-6{clip-path:url(#clip-path-3);}.cls-7{mask:url(#mask);}.cls-8{fill:url(#linear-gradient);}.cls-9{fill:url(#linear-gradient-2);}.cls-10{fill:url(#linear-gradient-3);}.cls-11{fill:url(#linear-gradient-4);}.cls-12{fill:url(#linear-gradient-5);}.cls-13{fill:url(#linear-gradient-6);}.cls-14{fill:url(#linear-gradient-7);}.cls-15{fill:url(#linear-gradient-8);}.cls-16{fill:url(#linear-gradient-9);}.cls-17{fill:url(#linear-gradient-10);}.cls-18,.cls-221{opacity:0.7;}.cls-18{mix-blend-mode:screen;}.cls-19{fill:url(#radial-gradient);}.cls-20{fill:url(#radial-gradient-3);}.cls-21{fill:url(#radial-gradient-4);}.cls-22,.cls-99{fill:url(#linear-gradient-11);}.cls-23{fill:url(#linear-gradient-12);}.cls-24{fill:url(#linear-gradient-13);}.cls-25{fill:url(#linear-gradient-14);}.cls-26{fill:url(#linear-gradient-15);}.cls-27{fill:url(#linear-gradient-16);}.cls-28{fill:url(#linear-gradient-17);}.cls-29{fill:url(#linear-gradient-18);}.cls-30{fill:url(#linear-gradient-19);}.cls-31{fill:url(#linear-gradient-20);}.cls-32{fill:url(#linear-gradient-21);}.cls-33{fill:url(#linear-gradient-22);}.cls-34{fill:url(#linear-gradient-23);}.cls-35{fill:url(#linear-gradient-24);}.cls-36{fill:url(#linear-gradient-25);}.cls-37{fill:url(#linear-gradient-26);}.cls-38{fill:url(#linear-gradient-27);}.cls-39{fill:url(#linear-gradient-28);}.cls-40{fill:url(#linear-gradient-29);}.cls-41{fill:url(#linear-gradient-30);}.cls-42{fill:url(#linear-gradient-31);}.cls-43{fill:url(#linear-gradient-32);}.cls-44{fill:url(#linear-gradient-33);}.cls-45{fill:url(#linear-gradient-34);}.cls-46{fill:url(#linear-gradient-35);}.cls-47{fill:url(#linear-gradient-36);}.cls-48{fill:url(#linear-gradient-37);}.cls-49{fill:url(#linear-gradient-38);}.cls-50{fill:url(#linear-gradient-39);}.cls-51{fill:url(#linear-gradient-40);}.cls-52{fill:url(#linear-gradient-41);}.cls-53{fill:url(#linear-gradient-42);}.cls-54{fill:url(#linear-gradient-43);}.cls-55{fill:url(#linear-gradient-44);}.cls-56{fill:url(#linear-gradient-45);}.cls-117,.cls-57{fill:url(#linear-gradient-46);}.cls-118,.cls-58{fill:url(#linear-gradient-47);}.cls-59{fill:url(#linear-gradient-48);}.cls-119,.cls-60{fill:url(#linear-gradient-49);}.cls-61{fill:url(#linear-gradient-50);}.cls-62{fill:url(#linear-gradient-51);}.cls-63{fill:url(#linear-gradient-52);}.cls-64{fill:url(#linear-gradient-53);}.cls-124,.cls-65{fill:url(#linear-gradient-54);}.cls-66{fill:url(#linear-gradient-55);}.cls-126,.cls-67{fill:url(#linear-gradient-56);}.cls-127,.cls-68{fill:url(#linear-gradient-57);}.cls-128,.cls-69{fill:url(#linear-gradient-58);}.cls-129,.cls-70{fill:url(#linear-gradient-59);}.cls-130,.cls-71{fill:url(#linear-gradient-60);}.cls-72{fill:url(#linear-gradient-61);}.cls-73{fill:url(#linear-gradient-62);}.cls-74{fill:url(#linear-gradient-63);}.cls-75{fill:url(#linear-gradient-64);}.cls-76{fill:url(#linear-gradient-65);}.cls-77{fill:url(#linear-gradient-66);}.cls-137,.cls-78{fill:url(#linear-gradient-67);}.cls-79{fill:url(#linear-gradient-68);}.cls-80{fill:url(#linear-gradient-69);}.cls-81{fill:url(#linear-gradient-70);}.cls-141,.cls-82{fill:url(#linear-gradient-71);}.cls-83{fill:url(#linear-gradient-72);}.cls-84{fill:url(#linear-gradient-73);}.cls-85{fill:url(#linear-gradient-74);}.cls-86{fill:url(#linear-gradient-75);}.cls-87{fill:url(#linear-gradient-76);}.cls-88{fill:url(#linear-gradient-77);}.cls-89{fill:url(#linear-gradient-78);}.cls-90{fill:url(#linear-gradient-79);}.cls-91{fill:url(#linear-gradient-80);}.cls-92{fill:url(#linear-gradient-81);}.cls-93{fill:url(#linear-gradient-82);}.cls-94{fill:url(#linear-gradient-83);}.cls-95{fill:url(#linear-gradient-84);}.cls-96{fill:url(#linear-gradient-85);}.cls-97{fill:url(#linear-gradient-86);}.cls-98{fill:url(#linear-gradient-87);}.cls-100,.cls-101,.cls-102,.cls-103,.cls-104,.cls-115,.cls-99{opacity:0.6;}.cls-100,.cls-101,.cls-102,.cls-103,.cls-104,.cls-105,.cls-106,.cls-107,.cls-109,.cls-110,.cls-111,.cls-112,.cls-116,.cls-117,.cls-118,.cls-119,.cls-120,.cls-121,.cls-122,.cls-123,.cls-124,.cls-125,.cls-126,.cls-127,.cls-128,.cls-129,.cls-130,.cls-131,.cls-132,.cls-133,.cls-134,.cls-135,.cls-136,.cls-137,.cls-138,.cls-139,.cls-140,.cls-141,.cls-142,.cls-143,.cls-150,.cls-221,.cls-99{mix-blend-mode:multiply;}.cls-100{fill:url(#linear-gradient-89);}.cls-101{fill:url(#linear-gradient-90);}.cls-102{fill:url(#linear-gradient-91);}.cls-103{fill:url(#linear-gradient-92);}.cls-105,.cls-106,.cls-107,.cls-109,.cls-110,.cls-111,.cls-112,.cls-116,.cls-120,.cls-121,.cls-122,.cls-123,.cls-125,.cls-131,.cls-132,.cls-133,.cls-134,.cls-135,.cls-136,.cls-138,.cls-139,.cls-140,.cls-142,.cls-143{opacity:0.3;}.cls-105{fill:url(#linear-gradient-94);}.cls-106{fill:url(#linear-gradient-95);}.cls-107{fill:url(#linear-gradient-105);}.cls-108{fill:url(#linear-gradient-106);}.cls-109{fill:url(#linear-gradient-107);}.cls-110{fill:url(#linear-gradient-108);}.cls-111{fill:url(#linear-gradient-119);}.cls-112{fill:url(#linear-gradient-120);}.cls-113{fill:url(#linear-gradient-126);}.cls-114{fill:url(#linear-gradient-127);}.cls-116{fill:url(#linear-gradient-128);}.cls-120{fill:url(#linear-gradient-132);}.cls-121{fill:url(#linear-gradient-133);}.cls-122{fill:url(#linear-gradient-134);}.cls-123{fill:url(#linear-gradient-135);}.cls-125{fill:url(#linear-gradient-137);}.cls-131{fill:url(#linear-gradient-143);}.cls-132{fill:url(#linear-gradient-144);}.cls-133{fill:url(#linear-gradient-145);}.cls-134{fill:url(#linear-gradient-146);}.cls-135{fill:url(#linear-gradient-147);}.cls-136{fill:url(#linear-gradient-148);}.cls-138{fill:url(#linear-gradient-150);}.cls-139{fill:url(#linear-gradient-151);}.cls-140{fill:url(#linear-gradient-152);}.cls-142{fill:url(#linear-gradient-154);}.cls-143{fill:url(#linear-gradient-155);}.cls-144{opacity:0.5;}.cls-145{fill:url(#linear-gradient-156);}.cls-146{fill:url(#linear-gradient-157);}.cls-147{fill:url(#linear-gradient-158);}.cls-148{fill:url(#linear-gradient-159);}.cls-149{fill:url(#linear-gradient-160);}.cls-151{fill:url(#linear-gradient-161);}.cls-152{fill:url(#linear-gradient-162);}.cls-153{fill:url(#linear-gradient-163);}.cls-154{fill:url(#linear-gradient-164);}.cls-155{fill:url(#linear-gradient-165);}.cls-156{fill:url(#linear-gradient-166);}.cls-157{fill:url(#linear-gradient-167);}.cls-158{fill:url(#linear-gradient-168);}.cls-159{fill:url(#linear-gradient-169);}.cls-160{fill:url(#linear-gradient-170);}.cls-161{fill:url(#linear-gradient-171);}.cls-162{fill:url(#linear-gradient-172);}.cls-163{fill:url(#linear-gradient-173);}.cls-164{fill:url(#linear-gradient-174);}.cls-165{fill:url(#linear-gradient-175);}.cls-166{fill:url(#linear-gradient-176);}.cls-167{fill:url(#linear-gradient-177);}.cls-168{fill:url(#linear-gradient-178);}.cls-169{fill:url(#linear-gradient-179);}.cls-170{fill:url(#linear-gradient-180);}.cls-171{fill:url(#linear-gradient-181);}.cls-172{fill:url(#linear-gradient-182);}.cls-173{fill:url(#linear-gradient-183);}.cls-174{fill:url(#linear-gradient-184);}.cls-175{fill:url(#linear-gradient-185);}.cls-176{fill:url(#linear-gradient-186);}.cls-177{fill:url(#linear-gradient-187);}.cls-178{fill:url(#linear-gradient-188);}.cls-179{fill:url(#linear-gradient-189);}.cls-180{fill:url(#linear-gradient-190);}.cls-181{fill:url(#linear-gradient-191);}.cls-182{fill:url(#linear-gradient-192);}.cls-183{fill:url(#linear-gradient-193);}.cls-184{fill:url(#linear-gradient-194);}.cls-185{fill:url(#linear-gradient-195);}.cls-186{fill:url(#linear-gradient-196);}.cls-187{fill:url(#linear-gradient-197);}.cls-188{fill:url(#linear-gradient-198);}.cls-189{fill:url(#linear-gradient-199);}.cls-190{fill:url(#linear-gradient-200);}.cls-191{fill:url(#linear-gradient-201);}.cls-192{fill:url(#linear-gradient-202);}.cls-193{fill:url(#linear-gradient-203);}.cls-194{fill:url(#linear-gradient-204);}.cls-195{fill:url(#linear-gradient-205);}.cls-196{fill:url(#linear-gradient-206);}.cls-197{fill:url(#linear-gradient-207);}.cls-198{fill:url(#linear-gradient-208);}.cls-199{fill:url(#linear-gradient-209);}.cls-200{fill:url(#linear-gradient-210);}.cls-201{fill:url(#linear-gradient-211);}.cls-202{fill:url(#linear-gradient-212);}.cls-203{fill:url(#linear-gradient-213);}.cls-204{fill:url(#linear-gradient-214);}.cls-205{fill:url(#linear-gradient-215);}.cls-206{fill:url(#linear-gradient-216);}.cls-207{fill:url(#linear-gradient-217);}.cls-208{fill:url(#linear-gradient-218);}.cls-209{fill:url(#linear-gradient-219);}.cls-210{fill:url(#linear-gradient-220);}.cls-211{fill:url(#linear-gradient-221);}.cls-212{fill:url(#linear-gradient-222);}.cls-213{fill:url(#linear-gradient-223);}.cls-214{fill:url(#linear-gradient-224);}.cls-215{fill:url(#linear-gradient-225);}.cls-216{fill:url(#linear-gradient-226);}.cls-217{fill:url(#linear-gradient-227);}.cls-218{fill:url(#linear-gradient-228);}.cls-219{fill:url(#linear-gradient-229);}.cls-220{fill:url(#linear-gradient-230);}.cls-222{fill:url(#linear-gradient-231);}.cls-223{fill:url(#linear-gradient-232);}.cls-224{fill:url(#linear-gradient-233);}.cls-225{fill:url(#linear-gradient-234);}.cls-226{fill:url(#linear-gradient-235);}.cls-227{fill:url(#linear-gradient-236);}.cls-228{fill:url(#linear-gradient-237);}.cls-229{fill:url(#linear-gradient-238);}.cls-230{fill:url(#linear-gradient-239);}.cls-231{fill:url(#linear-gradient-240);}.cls-232{fill:url(#linear-gradient-241);}.cls-233{fill:url(#linear-gradient-242);}.cls-234{fill:url(#linear-gradient-243);}.cls-235{fill:url(#linear-gradient-244);}.cls-236{fill:url(#linear-gradient-245);}.cls-237{fill:#e6e7e8;}.cls-238{fill:#ffd800;}.cls-239{fill:red;}"), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-2",
  x: 227.99,
  y: -4.9,
  width: 456.64,
  height: 171.82
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-2",
  transform: "translate(0 5.28)"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M679.43,158.13a253.57,253.57,0,0,0-445.93-45,2.94,2.94,0,0,0-.35,2.61A3,3,0,0,0,235,117.6l6.6,2.22a3.83,3.83,0,0,0,1.18.19,3.65,3.65,0,0,0,3-1.62A240.06,240.06,0,0,1,444.55,13.11,240.37,240.37,0,0,1,665.82,159.8a3.47,3.47,0,0,0,3.19,2.12h7.88a2.75,2.75,0,0,0,2.27-1.22A2.71,2.71,0,0,0,679.43,158.13Z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-3",
  transform: "translate(0 5.28)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-2",
  x: 227.99,
  y: -4.9,
  width: 456.64,
  height: 171.82
})), /*#__PURE__*/React.createElement("mask", {
  id: "mask",
  x: 227.56,
  y: 0,
  width: 457.44,
  height: 172.32,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 5.28)"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-1"
}, /*#__PURE__*/React.createElement("image", {
  width: 953,
  height: 359,
  transform: "translate(227.56 -5.28) scale(0.48)",
  xlinkHref: "data:image/png;base64,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"
})))), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: 577.55,
  y1: 368.9,
  x2: 577.39,
  y2: 391.37,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#bfbfbf"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2,
  stopColor: "#d6d6d6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.62,
  stopColor: "#f5f5f5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.82,
  stopColor: "#dcdcdc"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#bfbfbf"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-2",
  x1: 634.43,
  y1: 369.3,
  x2: 634.27,
  y2: 391.77,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-3",
  x1: 608.53,
  y1: 369.12,
  x2: 608.37,
  y2: 391.59,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-4",
  x1: 601.61,
  y1: 369.07,
  x2: 601.45,
  y2: 391.54,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-5",
  x1: 576.86,
  y1: 382.55,
  x2: 577.59,
  y2: 368.48,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.39,
  stopColor: "#fcfcfc"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.66,
  stopColor: "#f3f3f3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.88,
  stopColor: "#e4e4e4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#d9d9d9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-6",
  x1: 633.61,
  y1: 385.47,
  x2: 634.33,
  y2: 371.39,
  xlinkHref: "#linear-gradient-5"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-7",
  x1: 608.14,
  y1: 384.16,
  x2: 608.87,
  y2: 370.08,
  xlinkHref: "#linear-gradient-5"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-8",
  x1: 569.83,
  y1: 379.61,
  x2: 569.75,
  y2: 394.73,
  xlinkHref: "#linear-gradient-5"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-9",
  x1: 593.31,
  y1: 379.73,
  x2: 593.23,
  y2: 394.86,
  xlinkHref: "#linear-gradient-5"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-10",
  x1: 627.01,
  y1: 379.91,
  x2: 626.93,
  y2: 395.04,
  xlinkHref: "#linear-gradient-5"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "radial-gradient",
  cx: 592.15,
  cy: 381.3,
  r: 18.73,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.13,
  stopColor: "#e3e3e3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.42,
  stopColor: "#9d9d9d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.84,
  stopColor: "#2d2d2d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "radial-gradient-3",
  cx: 592.15,
  cy: 381.3,
  r: 18.73,
  xlinkHref: "#radial-gradient"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "radial-gradient-4",
  cx: 592.15,
  cy: 381.3,
  r: 18.73,
  xlinkHref: "#radial-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-11",
  x1: 555.27,
  y1: 376.27,
  x2: 555.88,
  y2: 405.3,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#8b959c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.17,
  stopColor: "#f1f1f2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4,
  stopColor: "#535c64"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.56,
  stopColor: "#f1f1f2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.77,
  stopColor: "#606972"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#8b959c"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-12",
  x1: 570.96,
  y1: 386.3,
  x2: 607.94,
  y2: 386.75,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-13",
  x1: 585.66,
  y1: 386.3,
  x2: 628.81,
  y2: 385.46,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-14",
  x1: 570.96,
  y1: 386.03,
  x2: 607.94,
  y2: 386.49,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-15",
  x1: 570.96,
  y1: 386.16,
  x2: 607.94,
  y2: 386.62,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-16",
  x1: 570.8,
  y1: 383.7,
  x2: 571.41,
  y2: 413.69,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-17",
  x1: 592.88,
  y1: 383.26,
  x2: 593.49,
  y2: 413.24,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-18",
  x1: 558.03,
  y1: 383.96,
  x2: 558.64,
  y2: 413.95,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-19",
  x1: 565.31,
  y1: 383.82,
  x2: 565.92,
  y2: 413.8,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-20",
  x1: 563.46,
  y1: 383.85,
  x2: 564.07,
  y2: 413.84,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-21",
  x1: 574.53,
  y1: 383.63,
  x2: 575.14,
  y2: 413.61,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-22",
  x1: 576.46,
  y1: 378.31,
  x2: 577.07,
  y2: 408.3,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-23",
  x1: 581.18,
  y1: 378.22,
  x2: 581.78,
  y2: 408.2,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-24",
  x1: 584.79,
  y1: 378.14,
  x2: 585.4,
  y2: 408.13,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-25",
  x1: 601.07,
  y1: 383.09,
  x2: 601.68,
  y2: 413.07,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-26",
  x1: 606.04,
  y1: 382.99,
  x2: 606.65,
  y2: 412.97,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-27",
  x1: 613.09,
  y1: 382.85,
  x2: 613.69,
  y2: 412.83,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-28",
  x1: 609.44,
  y1: 382.92,
  x2: 610.05,
  y2: 412.9,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-29",
  x1: 596.75,
  y1: 383.18,
  x2: 597.36,
  y2: 413.16,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-30",
  x1: 563.89,
  y1: 383.84,
  x2: 564.5,
  y2: 413.83,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-31",
  x1: 568.21,
  y1: 378.48,
  x2: 568.82,
  y2: 408.46,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-32",
  x1: 574.94,
  y1: 383.62,
  x2: 575.55,
  y2: 413.6,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-33",
  x1: 585.08,
  y1: 383.41,
  x2: 585.69,
  y2: 413.4,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-34",
  x1: 588.96,
  y1: 383.34,
  x2: 589.57,
  y2: 413.32,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-35",
  x1: 600.52,
  y1: 383.1,
  x2: 601.12,
  y2: 413.08,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-36",
  x1: 647.54,
  y1: 382.15,
  x2: 648.15,
  y2: 412.13,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-37",
  x1: 627.59,
  y1: 377.28,
  x2: 628.2,
  y2: 407.26,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-38",
  x1: 615.3,
  y1: 382.8,
  x2: 615.91,
  y2: 412.78,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-39",
  x1: 626.58,
  y1: 377.29,
  x2: 627.19,
  y2: 407.28,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-40",
  x1: 642.67,
  y1: 376.97,
  x2: 643.28,
  y2: 406.95,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-41",
  x1: 638.86,
  y1: 377.04,
  x2: 639.47,
  y2: 407.03,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-42",
  x1: 631.79,
  y1: 386.85,
  x2: 656.38,
  y2: 387.31,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#8b959c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.17,
  stopColor: "#f1f1f2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.34,
  stopColor: "#535c64"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.56,
  stopColor: "#f1f1f2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.77,
  stopColor: "#606972"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#8b959c"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-43",
  x1: 631.91,
  y1: 385.97,
  x2: 656.5,
  y2: 386.43,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#8b959c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.17,
  stopColor: "#f1f1f2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.56,
  stopColor: "#f1f1f2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.77,
  stopColor: "#606972"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#8b959c"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-44",
  x1: 633.64,
  y1: 365,
  x2: 632.27,
  y2: 389.65,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-45",
  x1: 569.6,
  y1: 361.44,
  x2: 568.23,
  y2: 386.09,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-46",
  x1: 580.43,
  y1: 362.04,
  x2: 579.06,
  y2: 386.69,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-47",
  x1: 609.94,
  y1: 368.96,
  x2: 608.57,
  y2: 393.61,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-48",
  x1: 608.18,
  y1: 368.86,
  x2: 606.81,
  y2: 393.52,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-49",
  x1: 609.19,
  y1: 368.91,
  x2: 607.82,
  y2: 393.57,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-50",
  x1: 585.51,
  y1: 367.6,
  x2: 584.14,
  y2: 392.26,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-51",
  x1: 589.08,
  y1: 367.8,
  x2: 587.72,
  y2: 392.45,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-52",
  x1: 591.91,
  y1: 367.95,
  x2: 590.54,
  y2: 392.61,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-53",
  x1: 595.71,
  y1: 368.17,
  x2: 594.34,
  y2: 392.82,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-54",
  x1: 599.72,
  y1: 368.39,
  x2: 598.35,
  y2: 393.05,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-55",
  x1: 600.65,
  y1: 363.16,
  x2: 599.28,
  y2: 387.82,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-56",
  x1: 601.66,
  y1: 368.5,
  x2: 600.29,
  y2: 393.15,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-57",
  x1: 605.4,
  y1: 368.7,
  x2: 604.03,
  y2: 393.36,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-58",
  x1: 613.17,
  y1: 369.14,
  x2: 611.8,
  y2: 393.79,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-59",
  x1: 617.05,
  y1: 369.35,
  x2: 615.68,
  y2: 394.01,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-60",
  x1: 625.59,
  y1: 369.83,
  x2: 624.22,
  y2: 394.48,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-61",
  x1: 628.54,
  y1: 369.99,
  x2: 627.17,
  y2: 394.65,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-62",
  x1: 648.24,
  y1: 371.08,
  x2: 646.87,
  y2: 395.74,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-63",
  x1: 638.61,
  y1: 365.27,
  x2: 637.24,
  y2: 389.93,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-64",
  x1: 616.88,
  y1: 369.34,
  x2: 615.51,
  y2: 394,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-65",
  x1: 621.46,
  y1: 369.6,
  x2: 620.09,
  y2: 394.25,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-66",
  x1: 607.72,
  y1: 368.83,
  x2: 606.35,
  y2: 393.49,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-67",
  x1: 609.01,
  y1: 368.9,
  x2: 607.64,
  y2: 393.56,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-68",
  x1: 628.98,
  y1: 370.01,
  x2: 627.61,
  y2: 394.67,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-69",
  x1: 642.76,
  y1: 365.5,
  x2: 641.39,
  y2: 390.16,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-70",
  x1: 585.72,
  y1: 362.33,
  x2: 584.35,
  y2: 386.99,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-71",
  x1: 563.8,
  y1: 361.11,
  x2: 562.43,
  y2: 385.77,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-72",
  x1: 630.84,
  y1: 370.12,
  x2: 629.47,
  y2: 394.77,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-73",
  x1: 630.49,
  y1: 364.82,
  x2: 629.12,
  y2: 389.48,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-74",
  x1: 577.49,
  y1: 361.88,
  x2: 576.12,
  y2: 386.53,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-75",
  x1: 565.43,
  y1: 366.48,
  x2: 564.06,
  y2: 391.14,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-76",
  x1: 637.56,
  y1: 365.21,
  x2: 636.19,
  y2: 389.87,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-77",
  x1: 627.45,
  y1: 369.93,
  x2: 626.08,
  y2: 394.59,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-78",
  x1: 622.66,
  y1: 377.37,
  x2: 623.27,
  y2: 407.36,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-79",
  x1: 618.65,
  y1: 382.73,
  x2: 619.26,
  y2: 412.72,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-80",
  x1: 604.37,
  y1: 386.16,
  x2: 629.71,
  y2: 386.16,
  xlinkHref: "#linear-gradient-43"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-81",
  x1: 618.76,
  y1: 385.75,
  x2: 617.39,
  y2: 410.41,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-82",
  x1: 613.65,
  y1: 390.74,
  x2: 612.28,
  y2: 415.4,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-83",
  x1: 615.95,
  y1: 390.87,
  x2: 614.58,
  y2: 415.53,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-84",
  x1: 615.6,
  y1: 385.57,
  x2: 614.23,
  y2: 410.23,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-85",
  x1: 594.7,
  y1: 389.71,
  x2: 593.33,
  y2: 414.37,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-86",
  x1: 592.48,
  y1: 389.59,
  x2: 591.11,
  y2: 414.25,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-87",
  x1: 593.77,
  y1: 389.66,
  x2: 592.4,
  y2: 414.32,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-89",
  x1: 558.82,
  y1: 376.2,
  x2: 559.43,
  y2: 405.23,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-90",
  x1: 594.14,
  y1: 368.08,
  x2: 592.77,
  y2: 392.74,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-91",
  x1: 581.89,
  y1: 367.4,
  x2: 580.52,
  y2: 392.05,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-92",
  x1: 569.77,
  y1: 375.97,
  x2: 570.38,
  y2: 405,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-94",
  x1: 616.91,
  y1: 387.32,
  x2: 622.12,
  y2: 387.4,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#535c64"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.04,
  stopColor: "#71797f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.12,
  stopColor: "#a8acb0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.18,
  stopColor: "#d0d2d4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.23,
  stopColor: "#e8e9ea"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.27,
  stopColor: "#f1f1f2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-95",
  x1: 607.55,
  y1: 386.62,
  x2: 615.19,
  y2: 386.66,
  xlinkHref: "#linear-gradient-94"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-105",
  x1: 591.59,
  y1: 397.83,
  x2: 592.66,
  y2: 392.36,
  xlinkHref: "#linear-gradient-94"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-106",
  x1: 593.04,
  y1: 383.25,
  x2: 593.65,
  y2: 413.24,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-107",
  x1: 606.41,
  y1: 387.54,
  x2: 606.29,
  y2: 396.15,
  xlinkHref: "#linear-gradient-94"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-108",
  x1: 613.26,
  y1: 389.53,
  x2: 613.31,
  y2: 390.09,
  xlinkHref: "#linear-gradient-94"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-119",
  x1: 615.31,
  y1: 389.35,
  x2: 615.36,
  y2: 389.9,
  xlinkHref: "#linear-gradient-94"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-120",
  x1: 620.33,
  y1: 385.78,
  x2: 614.31,
  y2: 385.92,
  xlinkHref: "#linear-gradient-94"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-126",
  x1: 632.51,
  y1: 377.17,
  x2: 633.12,
  y2: 407.16,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-127",
  x1: 641.68,
  y1: 382.26,
  x2: 642.29,
  y2: 412.25,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-128",
  x1: 569.6,
  y1: 361.44,
  x2: 568.23,
  y2: 386.09,
  xlinkHref: "#linear-gradient-94"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-132",
  x1: 585.51,
  y1: 367.6,
  x2: 584.14,
  y2: 392.26,
  xlinkHref: "#linear-gradient-94"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-133",
  x1: 589.08,
  y1: 367.8,
  x2: 587.72,
  y2: 392.45,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.09,
  stopColor: "#535c64"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.16,
  stopColor: "#71797f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3,
  stopColor: "#a8acb0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.42,
  stopColor: "#d0d2d4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.51,
  stopColor: "#e8e9ea"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.57,
  stopColor: "#f1f1f2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#535c64"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-134",
  x1: 591.29,
  y1: 372.41,
  x2: 591.43,
  y2: 382.37,
  xlinkHref: "#linear-gradient-94"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-135",
  x1: 598.63,
  y1: 371.18,
  x2: 593.35,
  y2: 371.28,
  xlinkHref: "#linear-gradient-94"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-137",
  x1: 600.65,
  y1: 363.16,
  x2: 599.28,
  y2: 387.82,
  xlinkHref: "#linear-gradient-94"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-143",
  x1: 628.42,
  y1: 372.93,
  x2: 628.47,
  y2: 370.3,
  xlinkHref: "#linear-gradient-94"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-144",
  x1: 647.53,
  y1: 377.95,
  x2: 647.99,
  y2: 387.22,
  xlinkHref: "#linear-gradient-94"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-145",
  x1: 632.85,
  y1: 370.73,
  x2: 642.45,
  y2: 380.91,
  xlinkHref: "#linear-gradient-94"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-146",
  x1: 616.88,
  y1: 369.34,
  x2: 615.51,
  y2: 394,
  xlinkHref: "#linear-gradient-94"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-147",
  x1: 621.46,
  y1: 369.6,
  x2: 620.09,
  y2: 394.25,
  xlinkHref: "#linear-gradient-94"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-148",
  x1: 607.32,
  y1: 376.2,
  x2: 607.38,
  y2: 375.02,
  xlinkHref: "#linear-gradient-94"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-150",
  x1: 628.98,
  y1: 370.01,
  x2: 627.61,
  y2: 394.67,
  xlinkHref: "#linear-gradient-94"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-151",
  x1: 647.65,
  y1: 372.33,
  x2: 634.44,
  y2: 372.43,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#535c64"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.09,
  stopColor: "#71797f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.27,
  stopColor: "#a8acb0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.43,
  stopColor: "#d0d2d4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.55,
  stopColor: "#e8e9ea"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.62,
  stopColor: "#f1f1f2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-152",
  x1: 574.01,
  y1: 360.09,
  x2: 597.95,
  y2: 360.33,
  xlinkHref: "#linear-gradient-94"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-154",
  x1: 577.49,
  y1: 361.88,
  x2: 576.12,
  y2: 386.53,
  xlinkHref: "#linear-gradient-94"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-155",
  x1: 628.99,
  y1: 365.33,
  x2: 634.3,
  y2: 365.06,
  xlinkHref: "#linear-gradient-94"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-156",
  x1: 555.38,
  y1: 375.48,
  x2: 555.38,
  y2: 396.91,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#bfbfbf"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.06,
  stopColor: "#cacaca"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.24,
  stopColor: "#e7e7e7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.39,
  stopColor: "#f9f9f9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.62,
  stopColor: "#f5f5f5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.82,
  stopColor: "#dcdcdc"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#bfbfbf"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-157",
  x1: 559.03,
  y1: 375.48,
  x2: 559.03,
  y2: 396.91,
  xlinkHref: "#linear-gradient-156"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-158",
  x1: 593.15,
  y1: 375.48,
  x2: 593.15,
  y2: 396.91,
  xlinkHref: "#linear-gradient-156"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-159",
  x1: 580.86,
  y1: 375.48,
  x2: 580.86,
  y2: 396.91,
  xlinkHref: "#linear-gradient-156"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-160",
  x1: 569.98,
  y1: 375.48,
  x2: 569.98,
  y2: 396.91,
  xlinkHref: "#linear-gradient-156"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-161",
  x1: 571.16,
  y1: 375.48,
  x2: 571.16,
  y2: 396.91,
  xlinkHref: "#linear-gradient-156"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-162",
  x1: 594.47,
  y1: 375.48,
  x2: 594.47,
  y2: 396.91,
  xlinkHref: "#linear-gradient-156"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-163",
  x1: 618.72,
  y1: 370.2,
  x2: 618.72,
  y2: 391.63,
  xlinkHref: "#linear-gradient-156"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-164",
  x1: 616.04,
  y1: 370.2,
  x2: 616.04,
  y2: 391.63,
  xlinkHref: "#linear-gradient-156"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-165",
  x1: 593.26,
  y1: 375.48,
  x2: 593.26,
  y2: 396.91,
  xlinkHref: "#linear-gradient-156"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-166",
  x1: 558.27,
  y1: 375.48,
  x2: 558.27,
  y2: 396.91,
  xlinkHref: "#linear-gradient-156"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-167",
  x1: 565.42,
  y1: 375.48,
  x2: 565.42,
  y2: 396.91,
  xlinkHref: "#linear-gradient-156"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-168",
  x1: 563.57,
  y1: 375.48,
  x2: 563.57,
  y2: 396.91,
  xlinkHref: "#linear-gradient-156"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-169",
  x1: 574.64,
  y1: 375.48,
  x2: 574.64,
  y2: 396.91,
  xlinkHref: "#linear-gradient-156"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-170",
  x1: 576.58,
  y1: 370.2,
  x2: 576.58,
  y2: 391.63,
  xlinkHref: "#linear-gradient-156"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-171",
  x1: 581.42,
  y1: 370.2,
  x2: 581.42,
  y2: 391.63,
  xlinkHref: "#linear-gradient-156"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-172",
  x1: 585.04,
  y1: 370.2,
  x2: 585.04,
  y2: 391.63,
  xlinkHref: "#linear-gradient-156"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-173",
  x1: 601.33,
  y1: 375.48,
  x2: 601.33,
  y2: 396.91,
  xlinkHref: "#linear-gradient-156"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-174",
  x1: 592.2,
  y1: 375.48,
  x2: 592.2,
  y2: 396.91,
  xlinkHref: "#linear-gradient-156"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-175",
  x1: 593.33,
  y1: 375.48,
  x2: 593.33,
  y2: 396.91,
  xlinkHref: "#linear-gradient-156"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-176",
  x1: 606.3,
  y1: 375.48,
  x2: 606.3,
  y2: 396.91,
  xlinkHref: "#linear-gradient-156"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-177",
  x1: 613.56,
  y1: 375.48,
  x2: 613.56,
  y2: 396.91,
  xlinkHref: "#linear-gradient-156"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-178",
  x1: 613.48,
  y1: 375.48,
  x2: 613.48,
  y2: 396.91,
  xlinkHref: "#linear-gradient-156"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-179",
  x1: 609.89,
  y1: 375.48,
  x2: 609.89,
  y2: 396.91,
  xlinkHref: "#linear-gradient-156"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-180",
  x1: 597.16,
  y1: 375.48,
  x2: 597.16,
  y2: 396.91,
  xlinkHref: "#linear-gradient-156"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-181",
  x1: 564.33,
  y1: 375.48,
  x2: 564.33,
  y2: 396.91,
  xlinkHref: "#linear-gradient-156"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-182",
  x1: 568.55,
  y1: 370.2,
  x2: 568.55,
  y2: 391.63,
  xlinkHref: "#linear-gradient-156"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-183",
  x1: 575.38,
  y1: 375.48,
  x2: 575.38,
  y2: 396.91,
  xlinkHref: "#linear-gradient-156"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-184",
  x1: 585.53,
  y1: 375.48,
  x2: 585.53,
  y2: 396.91,
  xlinkHref: "#linear-gradient-156"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-185",
  x1: 589.37,
  y1: 375.48,
  x2: 589.37,
  y2: 396.91,
  xlinkHref: "#linear-gradient-156"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-186",
  x1: 600.96,
  y1: 375.48,
  x2: 600.96,
  y2: 396.91,
  xlinkHref: "#linear-gradient-156"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-187",
  x1: 647.67,
  y1: 375.48,
  x2: 647.67,
  y2: 396.91,
  xlinkHref: "#linear-gradient-156"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-188",
  x1: 615.76,
  y1: 375.48,
  x2: 615.76,
  y2: 396.91,
  xlinkHref: "#linear-gradient-156"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-189",
  x1: 615.6,
  y1: 370.2,
  x2: 615.6,
  y2: 391.63,
  xlinkHref: "#linear-gradient-156"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-190",
  x1: 627.91,
  y1: 370.2,
  x2: 627.91,
  y2: 391.63,
  xlinkHref: "#linear-gradient-156"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-191",
  x1: 615.67,
  y1: 375.48,
  x2: 615.67,
  y2: 396.91,
  xlinkHref: "#linear-gradient-156"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-192",
  x1: 627.02,
  y1: 370.2,
  x2: 627.02,
  y2: 391.63,
  xlinkHref: "#linear-gradient-156"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-193",
  x1: 642.87,
  y1: 370.2,
  x2: 642.87,
  y2: 391.63,
  xlinkHref: "#linear-gradient-156"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-194",
  x1: 639.26,
  y1: 370.2,
  x2: 639.26,
  y2: 391.63,
  xlinkHref: "#linear-gradient-156"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-195",
  x1: 632.64,
  y1: 370.2,
  x2: 632.64,
  y2: 391.63,
  xlinkHref: "#linear-gradient-156"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-196",
  x1: 641.76,
  y1: 375.48,
  x2: 641.76,
  y2: 396.91,
  xlinkHref: "#linear-gradient-156"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-197",
  x1: 633.58,
  y1: 370.2,
  x2: 633.58,
  y2: 391.63,
  xlinkHref: "#linear-gradient-156"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-198",
  x1: 569.48,
  y1: 370.2,
  x2: 569.48,
  y2: 391.63,
  xlinkHref: "#linear-gradient-156"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-199",
  x1: 580.21,
  y1: 370.2,
  x2: 580.21,
  y2: 391.63,
  xlinkHref: "#linear-gradient-156"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-200",
  x1: 609.7,
  y1: 375.48,
  x2: 609.7,
  y2: 396.91,
  xlinkHref: "#linear-gradient-156"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-201",
  x1: 608.39,
  y1: 375.48,
  x2: 608.39,
  y2: 396.91,
  xlinkHref: "#linear-gradient-156"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-202",
  x1: 608.51,
  y1: 375.48,
  x2: 608.51,
  y2: 396.91,
  xlinkHref: "#linear-gradient-156"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-203",
  x1: 584.95,
  y1: 375.48,
  x2: 584.95,
  y2: 396.91,
  xlinkHref: "#linear-gradient-156"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-204",
  x1: 588.16,
  y1: 375.48,
  x2: 588.16,
  y2: 396.91,
  xlinkHref: "#linear-gradient-156"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-205",
  x1: 591.37,
  y1: 375.48,
  x2: 591.37,
  y2: 396.91,
  xlinkHref: "#linear-gradient-156"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-206",
  x1: 595.54,
  y1: 375.48,
  x2: 595.54,
  y2: 396.91,
  xlinkHref: "#linear-gradient-156"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-207",
  x1: 599.71,
  y1: 375.48,
  x2: 599.71,
  y2: 396.91,
  xlinkHref: "#linear-gradient-156"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-208",
  x1: 600.28,
  y1: 370.2,
  x2: 600.28,
  y2: 391.63,
  xlinkHref: "#linear-gradient-156"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-209",
  x1: 600.77,
  y1: 375.48,
  x2: 600.77,
  y2: 396.91,
  xlinkHref: "#linear-gradient-156"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-210",
  x1: 604.61,
  y1: 375.48,
  x2: 604.61,
  y2: 396.91,
  xlinkHref: "#linear-gradient-156"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-211",
  x1: 612.41,
  y1: 375.48,
  x2: 612.41,
  y2: 396.91,
  xlinkHref: "#linear-gradient-156"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-212",
  x1: 616.2,
  y1: 375.48,
  x2: 616.2,
  y2: 396.91,
  xlinkHref: "#linear-gradient-156"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-213",
  x1: 624.77,
  y1: 375.48,
  x2: 624.77,
  y2: 396.91,
  xlinkHref: "#linear-gradient-156"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-214",
  x1: 628.45,
  y1: 375.48,
  x2: 628.45,
  y2: 396.91,
  xlinkHref: "#linear-gradient-156"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-215",
  x1: 647.67,
  y1: 375.48,
  x2: 647.67,
  y2: 396.91,
  xlinkHref: "#linear-gradient-156"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-216",
  x1: 638.02,
  y1: 370.2,
  x2: 638.02,
  y2: 391.63,
  xlinkHref: "#linear-gradient-156"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-217",
  x1: 616.57,
  y1: 375.48,
  x2: 616.57,
  y2: 396.91,
  xlinkHref: "#linear-gradient-156"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-218",
  x1: 621.18,
  y1: 375.48,
  x2: 621.18,
  y2: 396.91,
  xlinkHref: "#linear-gradient-156"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-219",
  x1: 607.43,
  y1: 375.48,
  x2: 607.43,
  y2: 396.91,
  xlinkHref: "#linear-gradient-156"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-220",
  x1: 608.57,
  y1: 375.48,
  x2: 608.57,
  y2: 396.91,
  xlinkHref: "#linear-gradient-156"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-221",
  x1: 628.36,
  y1: 375.48,
  x2: 628.36,
  y2: 396.91,
  xlinkHref: "#linear-gradient-156"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-222",
  x1: 642.39,
  y1: 370.2,
  x2: 642.39,
  y2: 391.63,
  xlinkHref: "#linear-gradient-156"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-223",
  x1: 585.85,
  y1: 370.2,
  x2: 585.85,
  y2: 391.63,
  xlinkHref: "#linear-gradient-156"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-224",
  x1: 563.17,
  y1: 370.2,
  x2: 563.17,
  y2: 391.63,
  xlinkHref: "#linear-gradient-156"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-225",
  x1: 630.65,
  y1: 375.48,
  x2: 630.65,
  y2: 396.91,
  xlinkHref: "#linear-gradient-156"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-226",
  x1: 630.48,
  y1: 370.2,
  x2: 630.48,
  y2: 391.63,
  xlinkHref: "#linear-gradient-156"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-227",
  x1: 576.7,
  y1: 370.2,
  x2: 576.7,
  y2: 391.63,
  xlinkHref: "#linear-gradient-156"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-228",
  x1: 564.43,
  y1: 375.48,
  x2: 564.43,
  y2: 396.91,
  xlinkHref: "#linear-gradient-156"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-229",
  x1: 637.67,
  y1: 370.2,
  x2: 637.67,
  y2: 391.63,
  xlinkHref: "#linear-gradient-156"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-230",
  x1: 627.7,
  y1: 375.48,
  x2: 627.7,
  y2: 396.91,
  xlinkHref: "#linear-gradient-156"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-231",
  x1: 609.89,
  y1: 405.37,
  x2: 609.89,
  y2: 403.86,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-232",
  x1: 564.33,
  y1: 405.37,
  x2: 564.33,
  y2: 403.86,
  xlinkHref: "#linear-gradient-231"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-233",
  x1: 575.38,
  y1: 405.37,
  x2: 575.38,
  y2: 403.86,
  xlinkHref: "#linear-gradient-231"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-234",
  x1: 585.53,
  y1: 405.37,
  x2: 585.53,
  y2: 403.86,
  xlinkHref: "#linear-gradient-231"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-235",
  x1: 600.96,
  y1: 405.37,
  x2: 600.96,
  y2: 403.86,
  xlinkHref: "#linear-gradient-231"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-236",
  x1: 629.08,
  y1: 400.09,
  x2: 629.08,
  y2: 398.58,
  xlinkHref: "#linear-gradient-231"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-237",
  x1: 608.39,
  y1: 364.89,
  x2: 608.39,
  y2: 368.91,
  xlinkHref: "#linear-gradient-231"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-238",
  x1: 584.24,
  y1: 359.61,
  x2: 584.24,
  y2: 363.64,
  xlinkHref: "#linear-gradient-231"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-239",
  x1: 629.85,
  y1: 359.61,
  x2: 629.85,
  y2: 363.64,
  xlinkHref: "#linear-gradient-231"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-240",
  x1: 582.66,
  y1: 390.31,
  x2: 603.76,
  y2: 390.31,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-241",
  x1: 555.68,
  y1: 369.55,
  x2: 599.41,
  y2: 369.55,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-242",
  x1: 555.83,
  y1: 390.31,
  x2: 583.81,
  y2: 390.31,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-243",
  x1: 597.9,
  y1: 369.55,
  x2: 619,
  y2: 369.55,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-244",
  x1: 621.48,
  y1: 369.55,
  x2: 647.37,
  y2: 369.55,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-245",
  x1: 606.61,
  y1: 390.31,
  x2: 647.37,
  y2: 390.31,
  xlinkHref: "#linear-gradient-11"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M401.14,221l.72.1c5.41.74,10.72,1.71,14.79,3.53a15.26,15.26,0,0,1,8,7.52,23.24,23.24,0,0,1,.5,19.7c-2.08,4.49-6.62,8.26-10.77,10.25A39.77,39.77,0,0,1,401,265.73a47.82,47.82,0,0,1-25.37-4.53c-4.54-2.21-10.07-6-12.86-10.94a10.89,10.89,0,0,1,.51-11.7c4-5.44,12.5-6.65,18.93-6.42a78.76,78.76,0,0,1,18.37,3.36c1.29.47,6,2.31,6.87,3.17a2.29,2.29,0,0,1,.7,2.24c-1.06,3.25-9,5-11.24,5.31-6.1.93-9.27-1.38-16.21-4.12a24,24,0,0,0-5.77-1.59c-3.15-.29-7,.59-7.56,4-.3,1.77,1.78,3.43,3.37,4.12a25.37,25.37,0,0,0,10.41,2.23c10.82.17,23-1.61,31.84-7.88a4.93,4.93,0,0,0,2.41-3.72c0-3.23-5.61-5.2-5.61-5.2-6-2.49-17-3.69-22.66-4.16-5.95-.52-15.33-1.29-17.58-1.62a26.58,26.58,0,0,1-6.84-1.7,8.55,8.55,0,0,1-4.57-5.2c-1-4.06.29-9,2.54-12.3,5.92-8.5,19.77-11.73,30.13-13,10-1.25,26.21-1.24,36.05,4,1.52.81,2.3,1.57,2,3.19a7.89,7.89,0,0,1-5.71,5.88c-2.91.93-8.94,1.29-11.59,1.46-11.86.66-26.2.31-37.5,3.4a7.81,7.81,0,0,0-2.91,1.21c-1.77,1.93,3.28,2.47,4.36,2.7a6,6,0,0,0,.72.12l25,2.94m-70.58-52.9s1.93-2.9,3.54-5.09a92.44,92.44,0,0,1,12.29-13c1.22-1,2.67-2.23,2.67-2.23s-2.26.23-3.54.49c-3,.6-7.51,3.56-9.74,5.48-3.68,3.15-7.73,8.27-5.9,12.82.27.65.68,1.51.68,1.51M351,173.56a38.88,38.88,0,0,0,16.33-4.88c5-2.78,12.29-8.21,11.53-14.59a5.37,5.37,0,0,0-3.29-4.35c-2.22-1-3.37-.81-6.21,0a18.74,18.74,0,0,0-4.93,2.09,75.09,75.09,0,0,0-18.18,16.06c-1,1.34-2,2.83-2.84,3.85-.51.63-.9,1.21-.85,1.37.17.64,6.16.58,8.44.42m-14.81,10.88a25.1,25.1,0,0,0-1.89,3.27,6.43,6.43,0,0,1-1.43,1.66c-1.52,1.11-2.8,1.17-4.26-.12a10.42,10.42,0,0,1-3.32-7.34,22.44,22.44,0,0,0-.06-3.51c-.37-1.69-2.07-3.44-3-5.05a19.81,19.81,0,0,1-2-7.39c-.37-6.69,3.16-12.86,7.74-17.72a51.2,51.2,0,0,1,17.23-11.79c6.21-2.62,15.31-4.4,22.12-2a16.9,16.9,0,0,1,6.87,4.62,4.92,4.92,0,0,0,.94,1.08,6.84,6.84,0,0,0,1.72.38,17.4,17.4,0,0,1,6.59,3.12,12.67,12.67,0,0,1,4.63,7.41c1.3,6.19-2.26,13-6.32,17.11-6.95,7.11-13.81,12.11-22.7,15.59-3.9,1.52-10,3-14.41,2.55-1.38-.12-2.79-.48-4.13-.57a19.34,19.34,0,0,1-3.45-.88c-.34-.26-.76-.48-.84-.39m7.94,13.72a5.54,5.54,0,0,1,1.05.3c3.12,1.19,4.4,4.07,5.17,7.24,1.78,7.35,2.53,23.63,2.83,30,.21,4.78.33,9.49.53,14.21.17,4,.5,9.33-.34,13.08a6.11,6.11,0,0,1-2.5,3.71c-1.48.95-4.84,1-6.7.64-4.56-.95-6-3.88-6.69-8.39-1.55-10.77-.8-31.9.11-40.82.3-2.94,1.41-12.38,2.95-16.33.53-1.34,1.64-4,3.59-3.64M205.34,216.07s-6.79.48-11.46,1c-5.95.64-17.12,2.57-23.57,4.87-1.93.7-5.86,2.34-6.21,4.33s.92,3.67,2.35,5.34c.82,1,5.48,5.45,6.78,6.54a117.53,117.53,0,0,0,24.76,15c2.8,1.16,7.45,2.83,7.45,2.83s-.34-13.23-.28-26.27c0-6.88.18-13.68.18-13.68m124.52,5.27c.39,3.55-.53,10.27-.68,11.16a51.2,51.2,0,0,1-2.09,7.33,82.93,82.93,0,0,1-3.77,7.55,62.69,62.69,0,0,1-10.66,13.08c-11.69,10.1-29.79,15.86-45.31,17.75a115,115,0,0,1-33.8-1c-3.84-.7-9.56-2-9.56-2s0,2.28-.16,3.89a16.39,16.39,0,0,1-1,3.29,5.21,5.21,0,0,1-4.08,2.91,12.2,12.2,0,0,1-7-.34c-3.54-1.5-4.82-4.81-5.43-8.64-.51-3.07-1-8.39-1-8.39s-2.65-1.26-4.87-2.36A125.86,125.86,0,0,1,181.58,254c-1.56-1.17-8.28-6.79-9.77-8.19-4.16-3.95-7.9-7.89-10.75-12.93-2.21-3.93-2.85-7.43-1.17-11.61,2.33-5.81,10.67-10.19,16.37-12.69,4.2-1.85,17.22-6.11,22.64-6.89,2.55-.37,6.52-1.08,6.76-1.24a1.28,1.28,0,0,0,.24-.22c.13-.18.34-5.94.29-8s1.54-15.68,2.05-18.56c.27-1.55,1.44-7.54,2.65-9.11.78-1.06,2.18-1,3.31-.28,6.21,3.86,8.09,17.24,8.55,24.06.28,4.15.42,10.39.42,10.39s7.12-.21,11.5-.09A102.74,102.74,0,0,1,248,200.08c5.65.9,16.68,3.31,23,6.51,5.21,2.64,10.08,7.09,11.66,11.8,1.47,4.32,1.25,7.3-1,11.19-2.51,4.4-7.26,7.67-12.08,7.94-1.43.08-6.83-.63-8.49-1.92a1.47,1.47,0,0,1-.15-2.06c.18-.22,2.7-1.56,4.19-2.35a9.31,9.31,0,0,0,1.95-1.37c1.24-1.09,2.35-2.29,2.23-3.69-.18-1.83-2.11-3-3.95-3.68-8.63-3.43-25.87-6.28-34.21-6.77-3.26-.19-7.89-.36-7.89-.36l1,46s3.83.73,6.85,1.22c1.74.26,9.08.92,11,1,14.86.4,31.46-.93,45.1-7.38,6-2.82,11.48-6.32,15.64-11.07a32.16,32.16,0,0,0,7.6-23.88c-.83-9.81-7.74-21.46-13.26-28.55-14.57-18.75-39.55-34.16-61.52-43.2-22.44-9.22-44.61-14.53-68.43-15.41-6.13-.23-19.52.08-26.28,1.95-1,.27-1.94.6-2.84.8a7.82,7.82,0,0,0-2.14.89c-.16.14-.33.32-.33.32a8.27,8.27,0,0,0,.81.41c.72.31,3.74.5,5.3.78a5.13,5.13,0,0,1,3.42,2,2,2,0,0,1,0,2.55c-1.53,1.87-7.3,1.55-9.84,1.15s-5.93-1.23-6.53-3.53c-.7-2.7.58-5.36,2-7.81,2.8-4.91,6.79-7.46,12.65-9.07a129.28,129.28,0,0,1,26.67-4.18c17.78-.67,34.6,2.43,51.83,7.66a246.51,246.51,0,0,1,32.21,12.54,254.68,254.68,0,0,1,23.46,13.2c1.89,1.25,13,9.39,14.69,10.82,3.59,2.94,8.28,7.15,11.68,10.52,6.58,6.52,14.76,16.51,18.73,24.44.95,1.9,1.7,3.76,2.93,6A53.86,53.86,0,0,1,328.2,212c.3,1.29.74,3.18.8,3.26A47.22,47.22,0,0,1,329.86,221.34Zm223.48-10.17c-8.33,1.91-30.22,3-30.22,3l-2.76,8.65s10.94-.94,18.9-.11c0,0,2.58-.3,2.88,2.93a51.36,51.36,0,0,1-.25,6.24s-.17,1.95-2.94,2.45c-3,.5-23.58,1.3-23.58,1.3L512,246.88s-1.24,2.61,1.54,1.86c2.58-.69,24.14-4.73,26.95-4.15,3,.74,6.34,4.75,5.38,8.41-1.15,4.54-22.67,18.26-35.78,17.3,0,0-6.88.45-12.71-8.85-5.42-8.86,2.06-25.62,2.06-25.62s-3.43-7.84-.94-10.49c0,0,1.47-1.34,5.78-1.64l5.27-10.91s-6,.41-9.58-4c-3.33-4.2-3.61-6.12-1.05-7.28,2.73-1.35,27.75-5.91,45-5.34,0,0,6-.58,11.17,9.8,0,0,2.51,4.2-1.76,5.21Zm-64.76,42c-2.21,5.19-8,10.73-15.28,7.29s-18.53-26.75-18.53-26.75-4.32-8.69-5.16-8.47c0,0-.93-1.69-1.5,7.8s.11,27.89-3.66,30.79c-3.57,2.91-7.9,1.76-10.14-1.64-2-3.36-2.89-11.31-1.78-25.29,1.31-14,4.56-28.9,8.72-33.54s7.48-1.27,8.78-.05c0,0,5.55,5,14.71,19.81l1.62,2.73s8.32,14,9.19,13.93c0,0,.68.64,1.28.18.87-.25.52-4.73.52-4.73s-1.72-15.21-9.31-41a12.1,12.1,0,0,1-.38-6.22c.77-3.05,3.82-1.62,3.82-1.62s11.77,5.92,17.48,25.07,1.86,36.45-.38,41.67Zm126.61-11.47c-5.35,9.35-20.47,28.91-40.56,24.29-6.64,16.09-12.21,32.37-15.4,56.72,0,0-.7,4.73-4.63,3.09-3.9-1.37-10.32-7.85-11.62-16.81-1.4-11.77,3.85-31.69,14.56-54.52-3.12-5.08-5.25-12.33-3.43-22.67,0,0,2.69-19.19,22-36.49,0,0,2.31-2,3.65-1.39s.79,6.87-.38,9.9-9.8,17.89-9.8,17.89-5.35,10-3.85,18c10.12-15.55,33.1-46.89,47.34-37,4.79,3.43,7,10.87,7,18.9a42.73,42.73,0,0,1-4.85,20.15ZM611,217s-.8-6.18-6.84.62a147.25,147.25,0,0,0-22.11,31.13c7.91-.88,15.55-5.18,17.86-7.37,3.75-3.33,12.5-12.37,11.09-24.38Zm114.83-1.41H689.05a288.12,288.12,0,0,0-4.62-37.26,2.73,2.73,0,0,0-2.69-2.24h-8.49a2.49,2.49,0,0,0-1.91.9,2.53,2.53,0,0,0-.53,2.08,269.11,269.11,0,0,1,4.69,36.53H640.08a3,3,0,0,0-3,3v7.65a3,3,0,0,0,3,3H676c0,1.89,0,3.58,0,5.17a266.25,266.25,0,0,1-1.59,30.38,2.8,2.8,0,0,0,2.76,3.09h7.88a3,3,0,0,0,3-2.69,284.12,284.12,0,0,0,1.54-30.78c0-1.58,0-3.28,0-5.17h36.31a3,3,0,0,0,3-3v-7.65A3,3,0,0,0,725.87,215.63Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-5"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-6"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-6"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-7"
}, /*#__PURE__*/React.createElement("image", {
  width: 953,
  height: 359,
  transform: "translate(227.56) scale(0.48)",
  xlinkHref: "data:image/png;base64,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"
}))))), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M530.77,377.77H518.3a97.69,97.69,0,0,0-1.57-12.63.92.92,0,0,0-.91-.76h-2.88a.88.88,0,0,0-.65.31.84.84,0,0,0-.17.7,93.34,93.34,0,0,1,1.59,12.38h-12a1,1,0,0,0-1,1v2.59a1,1,0,0,0,1,1h12.18c0,.64,0,1.21,0,1.75a90,90,0,0,1-.54,10.29,1,1,0,0,0,.24.74.93.93,0,0,0,.7.31H517a1,1,0,0,0,1-.91,97,97,0,0,0,.52-10.43c0-.53,0-1.11,0-1.75h12.3a1,1,0,0,0,1-1v-2.59A1,1,0,0,0,530.77,377.77Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M161.37,377.77H148.9a97.69,97.69,0,0,0-1.57-12.63.93.93,0,0,0-.91-.76h-2.88a.88.88,0,0,0-.65.31.84.84,0,0,0-.17.7,91.69,91.69,0,0,1,1.58,12.38h-12a1,1,0,0,0-1,1v2.59a1,1,0,0,0,1,1h12.18c0,.64,0,1.21,0,1.75a90,90,0,0,1-.54,10.29,1,1,0,0,0,.24.74.93.93,0,0,0,.7.31h2.67a1,1,0,0,0,1-.91,97,97,0,0,0,.52-10.43c0-.53,0-1.11,0-1.75h12.3a1,1,0,0,0,1-1v-2.59A1,1,0,0,0,161.37,377.77Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M291.11,378.91c2.18-1.34,3.81-3.64,3.81-5.4a3.66,3.66,0,0,0-2.63-3.51c-1.87-.74-5-.8-8-.8l-6.42,0,.18,1.28c.58.05,2.33.21,3,.31.08,1.15.11,5.45.11,6.56v1.69c0,2.72,0,7.55-.11,8.89-.83.16-2.56.32-2.92.34l-.25,1.33c1.73-.16,3.53-.16,5.27-.16s3.42,0,5.11.16l-.25-1.32c-.73-.07-2.28-.24-2.88-.35-.07-1.46-.13-5.61-.13-7.45.58,0,1.48-.09,2.15-.14,1.09,1.3,7.94,9.06,9.9,10l2-.32C296.2,387.21,292.05,380.55,291.11,378.91Zm-3.22-.48a9,9,0,0,1-2.91.5c0-1.86,0-6.68.12-8.22,4.22.09,5.72,2,5.72,3.58A4.35,4.35,0,0,1,287.89,378.43Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M272.5,388.32c-.8-.11-1.8-.25-2.52-.4a90.12,90.12,0,0,1-3.65-9.08c-.82-2.3-2.27-6.46-2.77-8.14.47-.09,1.31-.21,2-.28l.2-1.31c-1.71.12-3.41.11-5.13.11-1.35,0-2.71-.05-4.05-.15l.05,1.3c.5.06,1.53.2,2.06.31-.8,2.12-5.65,15-6.76,17.17-.72.15-1.76.29-2.47.36l-.2,1.32c1.15-.11,2.32-.15,3.48-.15,1.54,0,3.28.08,4.82.18l-.24-1.31c-.7-.08-1.69-.2-2.29-.34a72.24,72.24,0,0,1,1.84-7.18c1.2-.14,4.66-.29,5.93-.3.47,1.06,2,5.63,2.64,7.52a25.15,25.15,0,0,1-2.63.31l-.32,1.33c1.66-.14,3.36-.16,5-.16a32.65,32.65,0,0,1,5.22.24Zm-15-9.58c.25-.73.73-2,1.23-3.37l0,0c.41-1.11.87-2.36,1.24-3.39.37,1.11.92,2.71,1.41,4.17l0,0,.91,2.69Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M208,389.62l.25-1.32c.39,0,2.15-.23,2.92-.35.09-1.54.11-6.18.11-8.74v-1.64c0-.67,0-5.33-.11-6.75-.74-.12-2.47-.33-2.88-.37l-.32-1.33a57.51,57.51,0,0,0,5.86.17,40.34,40.34,0,0,0,4.66-.18l-.32,1.34c-.41.05-2.15.27-2.89.38-.06.83-.1,3.14-.1,6.88v1.73c0,4.44,0,7.59.11,8.51.77.15,2.41.31,2.88.36l.32,1.33c-1.91-.18-3.93-.16-5.82-.16C211.11,389.48,209.54,389.52,208,389.62Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M237.56,369.13c1.38.12,2.77.16,4.17.16,1.06,0,2.12-.06,3.18-.16l-.12,1.27c-.3.08-1.59.37-1.94.45-.53.34-4.37,4.92-5.95,6.9,3,4.23,5.87,8.43,9,12.59l-1.88.45a41.07,41.07,0,0,1-6-6h0c-1.48-1.74-2.74-3.34-3.45-4.19a75.73,75.73,0,0,0-4.59,7.37c.59.12,1.68.28,2.09.32l.18,1.28c-.63,0-2.89-.11-4.48-.11-1.22,0-2.41.06-3.63.16l.44-1.32a9.78,9.78,0,0,0,1.87-.39c.88-.54,5.42-6.68,7-8.77-.77-1-1.72-2.29-2.65-3.55-1.44-1.95-2.91-4-3.68-4.79-.37-.11-1.5-.32-1.93-.4l-.19-1.33a26.86,26.86,0,0,0,4.56.19c1.68,0,3.37-.06,5-.14l-.38,1.31c-.7.08-1.55.19-2.08.3.76,1.24,2.87,4.36,3.77,5.53.87-1.18,2.89-4.06,3.73-5.54-.48-.11-1.46-.26-1.75-.3l-.25-1.31Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M202.77,373.75c0-.76-.28-2.66-3-3.76-1.39-.58-3.7-.83-7.49-.83h-6.6l.19,1.29c.59,0,2.32.19,3,.33.1,1.38.12,6,.12,6.62v1.11c0,2.08,0,7.72-.12,9.43-.58.09-2.34.31-2.91.37l-.25,1.31c1.78-.13,3.6-.15,5.38-.15s3.79,0,5.66.15l-.32-1.32c-.72-.07-2.65-.25-3.48-.37-.09-1.42-.12-6.81-.12-9.28V377.5c0-2.44,0-5.62.11-6.78a10.83,10.83,0,0,1,3.75.57,3.69,3.69,0,0,1,2.05,3.46c0,3.33-2.85,4.64-4.76,5.11l-.17,1.43c1.18-.18,4.92-.87,6.94-2.86A6.38,6.38,0,0,0,202.77,373.75Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M352.45,377.77H340a97.66,97.66,0,0,0-1.56-12.63.93.93,0,0,0-.91-.76h-2.88a.86.86,0,0,0-.65.31.85.85,0,0,0-.18.7,90.14,90.14,0,0,1,1.59,12.38h-12a1,1,0,0,0-1,1v2.59a1,1,0,0,0,1,1h12.18c0,.64,0,1.21,0,1.75a90,90,0,0,1-.54,10.29,1,1,0,0,0,.24.74.93.93,0,0,0,.7.31h2.66a1,1,0,0,0,1-.91,97,97,0,0,0,.52-10.43c0-.53,0-1.11,0-1.75h12.31a1,1,0,0,0,1-1v-2.59A1,1,0,0,0,352.45,377.77Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M599.94,359.89H573.05a7.16,7.16,0,0,0-3.69,1.28,5.66,5.66,0,0,0-2.27,4.41,6.92,6.92,0,0,0,1.31,3.84c.67.83,2.36,2.58,2.36,2.58a.21.21,0,0,1,.07.15.24.24,0,0,1-.24.24H555.15v6.83h18.56a6.08,6.08,0,0,0,4.42-10.14c-.41-.5-2.06-2.23-2.4-2.59a.21.21,0,0,1-.07-.15.19.19,0,0,1,.12-.18h8.94v13.06h6.87v-13h8.35Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M638.57,372.38c-1.15,0-1.23-.47-1.23-.53s.14-.19.14-.19a11.38,11.38,0,0,0,1.31-.9,5.52,5.52,0,0,0,2.09-4.52,5.79,5.79,0,0,0-2.07-4.63,7.55,7.55,0,0,0-4.35-1.72H621v19.33h7.64v-5.53l4.06,4.07a6,6,0,0,0,3.69,1.46H647.9v-6.84ZM633,367.8h-4.32v-2.45h4a1.26,1.26,0,0,1,1.36,1.26A1.18,1.18,0,0,1,633,367.8Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-10",
  d: "M603,359.89s-5.84,19.29-5.84,19.33h7.15l.88-2.79h6.58l.88,2.8h7.05l-6-19.33Zm3.89,11.27,1.65-5.36,1.65,5.36Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-11",
  d: "M584.52,380.65S578.65,400,578.65,400h-6.54l-2.24-7.43L567.56,400h-6.47l-6-19.32H563l1.57,5.25,1.46-5.25h8l1.64,5.25,1.58-5.25Zm51.1,0H647.9v6.26h-9.55a.19.19,0,0,0-.13.19.19.19,0,0,0,.07.14c.34.36,2,2.11,2.41,2.61A6,6,0,0,1,636.27,400h-14.8a6,6,0,0,1-3.7-1.45l-4.06-4.08V400h-7.64V380.65h13.51a7.58,7.58,0,0,1,4.35,1.71A5.78,5.78,0,0,1,626,387a5.54,5.54,0,0,1-2.1,4.52,11.38,11.38,0,0,1-1.31.9s-.14.07-.14.19.08.52,1.23.53h9.47a.23.23,0,0,0,.23-.24.2.2,0,0,0-.06-.15s-1.69-1.74-2.36-2.57a6.91,6.91,0,0,1-1.31-3.83,5.71,5.71,0,0,1,2.26-4.42A7.27,7.27,0,0,1,635.62,380.65Zm-16.49,6.73a1.26,1.26,0,0,0-1.36-1.27h-4v2.45h4.33A1.19,1.19,0,0,0,619.13,387.38Zm-20.63-6.73,6,19.32h-7l-.89-2.8H590L589.1,400H582s5.84-19.32,5.84-19.32ZM595,391.92l-1.65-5.36-1.65,5.36Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-12",
  d: "M577.27,376.71a5.2,5.2,0,0,0,.09-6.89l-.05-.06c-.35-.42-1.78-1.93-2.33-2.51a1.26,1.26,0,0,1,.49-2.11l.16-.05h10.16v13.06h4.74v-13h8.34V361H573.05A6.21,6.21,0,0,0,570,362a4.64,4.64,0,0,0-1.83,3.55,5.84,5.84,0,0,0,1.08,3.18c.64.79,2.27,2.48,2.29,2.5h0v0a1.27,1.27,0,0,1,.33.86,1.3,1.3,0,0,1-1.3,1.3H556.22v4.7h17.49A4.94,4.94,0,0,0,577.27,376.71Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-13",
  d: "M638.57,373.44c-2.24,0-2.3-1.43-2.3-1.59a1.3,1.3,0,0,1,.73-1.14h0a9.71,9.71,0,0,0,1.11-.78,4.41,4.41,0,0,0,1.69-3.68,4.76,4.76,0,0,0-1.71-3.83,6.5,6.5,0,0,0-3.67-1.45H622v17.19h5.51v-7l1.82,1.83,4.06,4.07a4.93,4.93,0,0,0,3,1.14h10.48v-4.71Zm-5.42-4.58h-5.54v-4.58h5a2.31,2.31,0,0,1,2.43,2.33A2.25,2.25,0,0,1,633.15,368.86Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-14",
  d: "M612.58,375.36l.23.74.65,2h4.82L613,361h-9.14c-1.62,5.37-4.21,13.9-5.2,17.19h4.94l.64-2,.23-.74h8.15Zm-2.36-3.13h-4.74l.42-1.38,1.65-5.36,1-3.31,1,3.31,1.65,5.36.42,1.38Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-15",
  d: "M578,381.77l-.54,1.81s-.78,2.63-.79,2.64l-1,3.28-1-3.28-1.41-4.51h-6.41l-1.25,4.48-1,3.56-1-3.54-1.35-4.5h-5.6l5.32,17.19h4.91l.13-.41.79-2.55,1.15-3.71,1-3.33,1,3.34,2,6.66h5c1.64-5.38,4.23-13.89,5.23-17.19H578Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-16",
  d: "M588.58,381.71c-1.62,5.38-4.21,13.91-5.2,17.2h4.94l.64-2,.23-.75h8.14l.23.75.66,2.06H603l-5.32-17.2ZM595,393h-4.74l.42-1.38,1.65-5.37,1-3.3,1,3.3,1.65,5.37.43,1.38Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-17",
  d: "M632.56,382.78a4.62,4.62,0,0,0-1.84,3.56,5.89,5.89,0,0,0,1.08,3.17c.64.79,2.28,2.47,2.29,2.48l0,0,0,0a1.32,1.32,0,0,1,.33.86,1.3,1.3,0,0,1-1.3,1.3h-9.47a2.78,2.78,0,0,1-1.69-.45,1.46,1.46,0,0,1-.61-1.14,1.3,1.3,0,0,1,.73-1.14h0a11.06,11.06,0,0,0,1.12-.77,4.43,4.43,0,0,0,1.68-3.69,4.71,4.71,0,0,0-1.71-3.82,6.62,6.62,0,0,0-3.67-1.46H607.14V398.9h5.5v-7l1.82,1.83,4.07,4.07a4.83,4.83,0,0,0,3,1.14h14.79a4.84,4.84,0,0,0,3.56-1.44,4.91,4.91,0,0,0,1.35-3.45,4.85,4.85,0,0,0-1.25-3.42l0-.06c-.3-.36-1.39-1.54-2.33-2.53a1.23,1.23,0,0,1-.39-.9,1.25,1.25,0,0,1,.89-1.21l.15,0h8.64v-4.14H635.62A6.14,6.14,0,0,0,632.56,382.78Zm-14.29,6.83h-5.55v-4.57h5a2.3,2.3,0,0,1,2.42,2.33A2.24,2.24,0,0,1,618.27,389.61Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-18"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-19",
  d: "M599.94,359.89H573.05a7.16,7.16,0,0,0-3.69,1.28,5.66,5.66,0,0,0-2.27,4.41,6.92,6.92,0,0,0,1.31,3.84c.67.83,2.36,2.58,2.36,2.58a.21.21,0,0,1,.07.15.24.24,0,0,1-.24.24H555.15v6.83h18.56a6.08,6.08,0,0,0,4.42-10.14c-.41-.5-2.06-2.23-2.4-2.59a.21.21,0,0,1-.07-.15.19.19,0,0,1,.12-.18h8.94v13.06h6.87v-13h8.35Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-19",
  d: "M638.57,372.38c-1.15,0-1.23-.47-1.23-.53s.14-.19.14-.19a11.38,11.38,0,0,0,1.31-.9,5.52,5.52,0,0,0,2.09-4.52,5.79,5.79,0,0,0-2.07-4.63,7.55,7.55,0,0,0-4.35-1.72H621v19.33h7.64v-5.53l4.06,4.07a6,6,0,0,0,3.69,1.46H647.9v-6.84ZM633,367.8h-4.32v-2.45h4a1.26,1.26,0,0,1,1.36,1.26A1.18,1.18,0,0,1,633,367.8Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-20",
  d: "M603,359.89s-5.84,19.29-5.84,19.33h7.15l.88-2.79h6.58l.88,2.8h7.05l-6-19.33Zm3.89,11.27,1.65-5.36,1.65,5.36Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-21",
  d: "M584.52,380.65S578.65,400,578.65,400h-6.54l-2.24-7.43L567.56,400h-6.47l-6-19.32H563l1.57,5.25,1.46-5.25h8l1.64,5.25,1.58-5.25Zm51.1,0H647.9v6.26h-9.55a.19.19,0,0,0-.13.19.19.19,0,0,0,.07.14c.34.36,2,2.11,2.41,2.61A6,6,0,0,1,636.27,400h-14.8a6,6,0,0,1-3.7-1.45l-4.06-4.08V400h-7.64V380.65h13.51a7.58,7.58,0,0,1,4.35,1.71A5.78,5.78,0,0,1,626,387a5.54,5.54,0,0,1-2.1,4.52,11.38,11.38,0,0,1-1.31.9s-.14.07-.14.19.08.52,1.23.53h9.47a.23.23,0,0,0,.23-.24.2.2,0,0,0-.06-.15s-1.69-1.74-2.36-2.57a6.91,6.91,0,0,1-1.31-3.83,5.71,5.71,0,0,1,2.26-4.42A7.27,7.27,0,0,1,635.62,380.65Zm-16.49,6.73a1.26,1.26,0,0,0-1.36-1.27h-4v2.45h4.33A1.19,1.19,0,0,0,619.13,387.38Zm-20.63-6.73,6,19.32h-7l-.89-2.8H590L589.1,400H582s5.84-19.32,5.84-19.32ZM595,391.92l-1.65-5.36-1.65,5.36Z",
  transform: "translate(0 5.28)"
})), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-22",
  points: "555.61 378.12 555.15 377.67 555.15 384.49 555.61 384.04 555.61 378.12"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-23",
  points: "562.61 386.38 562.95 385.92 555.11 385.92 555.73 386.38 562.61 386.38"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-24",
  points: "598.16 386.38 598.5 385.92 587.79 385.93 588.13 386.38 598.16 386.38"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-25",
  points: "583.91 386.38 584.52 385.93 577.2 385.93 577.53 386.38 583.91 386.38"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-26",
  points: "573.65 386.38 573.99 385.93 565.98 385.92 566.33 386.38 573.65 386.38"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-27",
  points: "569.88 396.26 569.87 397.82 572.11 405.25 572.45 404.79 569.88 396.26"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-28",
  points: "589.64 402 589.98 402.45 596.55 402.45 596.88 401.99 589.64 402"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-29",
  points: "555.87 386.85 555.73 386.38 555.11 385.92 561.09 405.25 561.42 404.79 555.87 386.85"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-30",
  points: "565.98 385.92 564.52 391.18 564.53 392.83 566.33 386.38 565.98 385.92"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-31",
  points: "564.52 391.18 562.95 385.92 562.61 386.38 564.53 392.83 564.52 391.18"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-32",
  points: "575.62 391.18 573.99 385.93 573.65 386.38 575.63 392.73 575.62 391.18"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-33",
  d: "M577.2,380.65l-1.58,5.25v1.55s1.84-6.12,1.9-6.35Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-34",
  d: "M583.91,381.1l-5.6,18.41.34.46,5.87-19.32Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-35",
  d: "M587.79,380.65S582,399.94,582,400l.61-.46c.72-2.4,5.5-18.17,5.57-18.41Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-36",
  points: "598.5 385.92 598.16 386.38 603.87 404.79 604.49 405.25 598.5 385.92"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-37",
  points: "606.53 386.38 606.07 385.93 606.07 405.25 606.53 404.79 606.53 386.38"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-38",
  points: "613.25 398.61 613.25 404.79 613.71 405.25 613.71 399.72 613.25 398.61"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-39",
  points: "613.25 404.79 606.53 404.79 606.07 405.25 613.71 405.25 613.25 404.79"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-40",
  points: "596.88 401.99 596.55 402.45 597.44 405.25 597.78 404.79 596.88 401.99"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-41",
  points: "567.23 404.79 561.42 404.79 561.09 405.25 567.57 405.25 567.23 404.79"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-42",
  d: "M567.23,399.51l.33.46,2.31-7.43V391Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-43",
  points: "578.31 404.79 572.45 404.79 572.11 405.25 578.65 405.25 578.31 404.79"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-44",
  points: "588.77 404.79 582.56 404.79 581.95 405.25 589.1 405.25 588.77 404.79"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-45",
  points: "589.64 402 588.77 404.79 589.1 405.25 589.98 402.45 589.64 402"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-46",
  points: "603.87 404.79 597.78 404.79 597.44 405.25 604.49 405.25 603.87 404.79"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-47",
  points: "647.44 386.38 647.44 391.73 647.9 392.19 647.9 385.92 647.44 386.38"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-48",
  d: "M633.38,393h0a.24.24,0,0,1-.22.16h-9.47c-.83,0-1.1-.24-1.19-.4H622c.05.24.28.73,1.28.83.12,0,.25,0,.39,0h9.47a.69.69,0,0,0,.63-.43Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-49",
  points: "614.03 399.4 613.25 398.61 613.71 399.72 617.77 403.79 618.09 403.47 614.03 399.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-50",
  d: "M621.47,399.51a6.19,6.19,0,0,1-2.14-.5,3.94,3.94,0,0,1-1.24-.82l-.32.33a4.27,4.27,0,0,0,1.25.85,6.83,6.83,0,0,0,2.45.6h14.8v-.46Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-51",
  d: "M638.25,387a.2.2,0,0,1,.1-.08h9.55l-.46-.45h-9.22a.66.66,0,0,0-.38.31l.41.21Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-52",
  d: "M640.7,389.85c-.19-.23-.65-.73-1.12-1.24s-1.1-1.18-1.29-1.37a.19.19,0,0,1-.07-.14.45.45,0,0,1,0-.11h0l-.41-.21a.83.83,0,0,0-.07.32.61.61,0,0,0,.21.47l1.35,1.44c.43.47.84.92,1,1.13l0,.06a5.5,5.5,0,0,1,1.39,3.81,5.37,5.37,0,0,1-5.52,5.5V400a6.07,6.07,0,0,0,4.43-10.12Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-53",
  d: "M635.62,380.65a7.27,7.27,0,0,0-3.7,1.27,5.71,5.71,0,0,0-2.26,4.42,6.91,6.91,0,0,0,1.31,3.83c.67.83,2.36,2.57,2.36,2.57a.2.2,0,0,1,.06.15.22.22,0,0,1,0,.08h0l.41.19a.6.6,0,0,0,.06-.27.64.64,0,0,0-.18-.45h0s-1.68-1.72-2.34-2.53a6.52,6.52,0,0,1-1.21-3.55,5.24,5.24,0,0,1,2.09-4,6.81,6.81,0,0,1,3.42-1.19v-.45Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-54",
  points: "635.63 385.92 635.62 386.38 647.44 386.38 647.9 385.92 635.63 385.92"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-55",
  d: "M632.75,364.91l0,.45h0a1.25,1.25,0,0,1,1.31,1.26,1.18,1.18,0,0,1-1,1.18l.07.46a1.63,1.63,0,0,0,1.4-1.64A1.68,1.68,0,0,0,632.75,364.91Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-56",
  d: "M571.28,372.15a.73.73,0,0,0-.17-.46h0s-1.68-1.74-2.33-2.54a6.53,6.53,0,0,1-1.21-3.56,5.24,5.24,0,0,1,2.08-4,6.93,6.93,0,0,1,2.25-1l-.11-.44a7.32,7.32,0,0,0-2.41,1.09,5.66,5.66,0,0,0-2.27,4.41,6.92,6.92,0,0,0,1.31,3.84c.67.83,2.36,2.58,2.36,2.58a.21.21,0,0,1,.07.15.17.17,0,0,1,0,.1l.4.23A.73.73,0,0,0,571.28,372.15Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-57",
  d: "M575.78,365.7h-.06l-.07,0a.6.6,0,0,0-.4.39l.44.13h0a.14.14,0,0,1,.09-.08h8.94l.46-.46Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-58",
  points: "610.22 376.44 610.84 376.9 608.57 369.53 608.57 371.08 610.22 376.44"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-59",
  points: "613.4 365.63 613.74 365.17 603.03 365.17 603.37 365.63 613.4 365.63"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-60",
  points: "604.88 381.24 605.22 381.7 611.8 381.7 612.13 381.24 604.88 381.24"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-61",
  points: "584.72 371.44 584.72 384.49 585.18 384.04 585.18 370.98 584.72 371.44"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-62",
  points: "591.14 384.04 585.18 384.04 584.72 384.49 591.59 384.49 591.14 384.04"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-63",
  points: "591.14 371.01 591.14 384.04 591.59 384.49 591.59 371.47 591.14 371.01"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-64",
  points: "599.48 371.01 591.14 371.01 591.59 371.47 599.94 371.47 599.48 371.01"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-65",
  points: "599.48 365.63 599.48 371.01 599.94 371.47 599.94 365.17 599.48 365.63"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-66",
  d: "M603,359.89s-5.84,19.3-5.84,19.33l.61-.46,5.57-18.41Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-67",
  points: "604.01 384.04 597.8 384.04 597.19 384.49 604.34 384.49 604.01 384.04"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-68",
  points: "604.88 381.24 604.01 384.04 604.34 384.49 605.22 381.7 604.88 381.24"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-69",
  points: "612.13 381.24 611.8 381.7 612.68 384.5 613.02 384.04 612.13 381.24"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-70",
  points: "619.11 384.04 613.02 384.04 612.68 384.5 619.73 384.49 619.11 384.04"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-71",
  points: "628.14 384.04 621.41 384.04 620.95 384.5 628.59 384.49 628.14 384.04"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-72",
  points: "628.67 370.64 628.22 370.18 628.22 373.54 628.68 373.08 628.67 370.64"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-73",
  points: "647.44 378.11 647.44 384.04 647.9 384.49 647.9 377.65 647.44 378.11"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-74",
  d: "M647.44,378.76H636.35a5.46,5.46,0,0,1-3.37-1.32l-4.06-4.07-.78-.79.45,1.11,4.06,4.07a6,6,0,0,0,3.69,1.46H647.9Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-75",
  points: "613.74 365.17 613.4 365.63 619.11 384.04 619.73 384.49 613.74 365.17"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-76",
  points: "621.41 365.63 620.95 365.17 620.95 384.5 621.41 384.04 621.41 365.63"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-77",
  points: "606.3 376.9 606.92 376.44 608.57 371.08 608.57 369.53 606.3 376.9"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-78",
  points: "610.22 376.44 606.92 376.44 606.3 376.9 610.84 376.9 610.22 376.44"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-79",
  points: "628.14 377.86 628.14 384.04 628.59 384.49 628.59 378.97 628.14 377.86"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-80",
  d: "M638.57,372.38h-.16c-.8,0-1-.31-1.06-.45h-.47a1,1,0,0,0,.75.79,2.9,2.9,0,0,0,.94.13h8.87l.46-.45Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-81",
  d: "M573.05,359.89l-.3,0a5.17,5.17,0,0,0-1,.17l.11.44a4.92,4.92,0,0,1,1.08-.17h26.52l.46-.46Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-82",
  d: "M570.8,372.25a.24.24,0,0,1-.21.14H555.15l.46.45h15a.69.69,0,0,0,.61-.36Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-83",
  points: "633 373.08 628.68 373.08 628.22 373.54 633 373.54 633.04 373.54 633.07 373.54 633 373.08"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-84",
  d: "M628.21,364.9l.46.46h4l0-.45Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-85",
  d: "M578.13,369.08c-.29-.36-1.24-1.37-1.87-2l-.53-.55a.21.21,0,0,1-.07-.15.19.19,0,0,1,0-.1h0l-.44-.13a.59.59,0,0,0,0,.23.64.64,0,0,0,.21.47l.55.59c.61.64,1.53,1.62,1.82,2l.05.06a5.54,5.54,0,0,1-4.12,9.33v.46a6.08,6.08,0,0,0,4.42-10.14Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-86",
  points: "555.61 384.04 555.15 384.49 573.71 384.49 573.71 384.04 555.61 384.04"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-87",
  d: "M638.81,361.61a7.55,7.55,0,0,0-4.35-1.72v.46a7.12,7.12,0,0,1,4.06,1.6,5.32,5.32,0,0,1,1.92,4.29,5.07,5.07,0,0,1-1.92,4.16,11,11,0,0,1-1.23.85h0a.68.68,0,0,0-.39.6v.06h.47a.23.23,0,0,1,0-.07c0-.12.14-.19.14-.19a11.38,11.38,0,0,0,1.31-.9,5.52,5.52,0,0,0,2.09-4.52A5.79,5.79,0,0,0,638.81,361.61Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-88",
  points: "620.95 365.17 621.41 365.63 634.45 365.63 634.46 365.17 620.95 365.17"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-89",
  d: "M623.93,382.36a7.58,7.58,0,0,0-4.35-1.71v.46a7.08,7.08,0,0,1,4.06,1.6,5.31,5.31,0,0,1,1.92,4.28,5,5,0,0,1-1.92,4.17,9.8,9.8,0,0,1-1.23.84h0a.7.7,0,0,0-.39.6.4.4,0,0,0,0,.13h.48a.34.34,0,0,1,0-.13c0-.12.14-.19.14-.19a11.38,11.38,0,0,0,1.31-.9A5.54,5.54,0,0,0,626,387,5.78,5.78,0,0,0,623.93,382.36Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-90",
  x: 617.86,
  y: 385.93,
  width: 1.71,
  height: 0.46
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-91",
  points: "606.07 385.93 606.53 386.38 619.57 386.38 619.58 385.93 606.07 385.93"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-92",
  d: "M617.87,385.66l0,.45h0a1.25,1.25,0,0,1,1.31,1.27,1.19,1.19,0,0,1-1,1.18l.07.45a1.62,1.62,0,0,0,1.39-1.63A1.68,1.68,0,0,0,617.87,385.66Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-93",
  points: "613.79 391.39 613.33 390.93 613.34 394.29 613.79 393.84 613.79 391.39"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-94",
  points: "618.12 393.84 613.79 393.84 613.34 394.29 618.12 394.29 618.15 394.29 618.18 394.29 618.12 393.84"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-95",
  d: "M613.33,385.66l.46.45h4l0-.45Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-96",
  points: "594.98 397.2 595.6 397.65 593.33 390.28 593.33 391.83 594.98 397.2"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-97",
  points: "591.06 397.65 591.68 397.2 593.33 391.83 593.33 390.28 591.06 397.65"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-98",
  points: "594.98 397.2 591.68 397.2 591.06 397.65 595.6 397.65 594.98 397.2"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-99",
  points: "555.61 378.12 555.15 377.67 555.15 384.49 555.61 384.04 555.61 378.12"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-100",
  points: "562.61 386.38 562.95 385.92 555.11 385.92 555.73 386.38 562.61 386.38"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-101",
  points: "598.16 386.38 598.5 385.92 587.79 385.93 588.13 386.38 598.16 386.38"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-102",
  points: "583.91 386.38 584.52 385.93 577.2 385.93 577.53 386.38 583.91 386.38"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-103",
  points: "573.65 386.38 573.99 385.93 565.98 385.92 566.33 386.38 573.65 386.38"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-104"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-27",
  points: "569.88 396.26 569.87 397.82 572.11 405.25 572.45 404.79 569.88 396.26"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-105",
  d: "M617.86,385.66v.46h0a1.24,1.24,0,0,1,1.27,1.26,1.19,1.19,0,0,1-1,1.18l.06.45a1.62,1.62,0,0,0,1.4-1.63A1.69,1.69,0,0,0,617.86,385.66Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-106",
  d: "M619.57,381.11a7.08,7.08,0,0,1,4.06,1.6,5.31,5.31,0,0,1,1.92,4.28,5,5,0,0,1-1.92,4.17,9.8,9.8,0,0,1-1.23.84h0a.7.7,0,0,0-.39.6.4.4,0,0,0,0,.13h.48a.34.34,0,0,1,0-.13c0-.12.14-.19.14-.19a11.38,11.38,0,0,0,1.31-.9A5.54,5.54,0,0,0,626,387a5.78,5.78,0,0,0-2.08-4.63,7.58,7.58,0,0,0-4.35-1.71H606.07l.46.46Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-28",
  points: "589.64 402 589.98 402.45 596.55 402.45 596.88 401.99 589.64 402"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-29",
  points: "555.87 386.85 555.73 386.38 555.11 385.92 561.09 405.25 561.42 404.79 555.87 386.85"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-30",
  points: "565.98 385.92 564.52 391.18 564.53 392.83 566.33 386.38 565.98 385.92"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-31",
  points: "564.52 391.18 562.95 385.92 562.61 386.38 564.53 392.83 564.52 391.18"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-32",
  points: "575.62 391.18 573.99 385.93 573.65 386.38 575.63 392.73 575.62 391.18"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-33",
  d: "M577.2,380.65l-1.58,5.25v1.55s1.84-6.12,1.9-6.35Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-34",
  d: "M583.91,381.1l-5.6,18.41.34.46,5.87-19.32Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-35",
  d: "M587.79,380.65S582,399.94,582,400l.61-.46c.72-2.4,5.5-18.17,5.57-18.41Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-36",
  points: "598.5 385.92 598.16 386.38 603.87 404.79 604.49 405.25 598.5 385.92"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-107",
  points: "591.06 397.65 591.68 397.2 593.33 391.83 593.33 390.28 591.06 397.65"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-108",
  points: "594.98 397.2 591.68 397.2 591.06 397.65 595.6 397.65 594.98 397.2"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-109",
  points: "606.53 386.38 606.07 385.93 606.07 405.25 606.53 404.79 606.53 386.38"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-110",
  points: "613.33 390.93 613.33 394.29 613.79 393.84 613.79 391.39 613.33 390.93"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-38",
  points: "613.25 398.61 613.25 404.79 613.71 405.25 613.71 399.72 613.25 398.61"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-39",
  points: "613.25 404.79 606.53 404.79 606.07 405.25 613.71 405.25 613.25 404.79"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-40",
  points: "596.88 401.99 596.55 402.45 597.44 405.25 597.78 404.79 596.88 401.99"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-41",
  points: "567.23 404.79 561.42 404.79 561.09 405.25 567.57 405.25 567.23 404.79"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-42",
  d: "M567.23,399.51l.33.46,2.31-7.43V391Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-43",
  points: "578.31 404.79 572.45 404.79 572.11 405.25 578.65 405.25 578.31 404.79"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-44",
  points: "588.77 404.79 582.56 404.79 581.95 405.25 589.1 405.25 588.77 404.79"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-45",
  points: "589.64 402 588.77 404.79 589.1 405.25 589.98 402.45 589.64 402"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-46",
  points: "603.87 404.79 597.78 404.79 597.44 405.25 604.49 405.25 603.87 404.79"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "cls-47",
  points: "647.44 391.73 647.9 392.19 647.9 385.92 647.44 386.38"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-111",
  points: "618.12 393.84 613.79 393.84 613.33 394.29 618.12 394.29 618.15 394.29 618.18 394.29 618.12 393.84"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-112",
  d: "M613.33,385.66l.46.45h4.07v-.46Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-48",
  d: "M633.38,393h0a.24.24,0,0,1-.22.16h-9.47c-.83,0-1.1-.24-1.19-.4H622c.05.24.28.73,1.28.83.12,0,.25,0,.39,0h9.47a.69.69,0,0,0,.63-.43Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-49",
  points: "614.03 399.4 613.25 398.61 613.71 399.72 617.77 403.79 618.09 403.47 614.03 399.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-50",
  d: "M621.47,399.51a6.19,6.19,0,0,1-2.14-.5,3.94,3.94,0,0,1-1.24-.82l-.32.33a4.27,4.27,0,0,0,1.25.85,6.83,6.83,0,0,0,2.45.6h14.8v-.46Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-51",
  d: "M647.9,386.91l-.46-.45h-9.22a.66.66,0,0,0-.38.31l.41.21h0a.2.2,0,0,1,.1-.08",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-52",
  d: "M639.58,388.61c-.54-.58-1.1-1.18-1.29-1.37a.19.19,0,0,1-.07-.14.45.45,0,0,1,0-.11h0l-.41-.21a.83.83,0,0,0-.07.32.61.61,0,0,0,.21.47l1.35,1.44c.43.47.84.92,1,1.13l0,.06a5.5,5.5,0,0,1,1.39,3.81,5.37,5.37,0,0,1-5.52,5.5V400a6.07,6.07,0,0,0,4.43-10.12",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-113",
  d: "M635.62,380.65a7.27,7.27,0,0,0-3.7,1.27,5.71,5.71,0,0,0-2.26,4.42,6.91,6.91,0,0,0,1.31,3.83c.67.83,2.36,2.57,2.36,2.57a.2.2,0,0,1,.06.15.22.22,0,0,1,0,.08h0l.41.19a.6.6,0,0,0,.06-.27.64.64,0,0,0-.18-.45h0s-1.68-1.72-2.34-2.53a6.52,6.52,0,0,1-1.21-3.55,5.24,5.24,0,0,1,2.09-4,6.81,6.81,0,0,1,3.42-1.19v-.45Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-114",
  points: "635.63 385.92 635.62 386.38 647.44 386.38 647.9 385.92 635.63 385.92"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-115"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-116",
  d: "M571.28,372.15a.73.73,0,0,0-.17-.46h0s-1.68-1.74-2.33-2.54a6.53,6.53,0,0,1-1.21-3.56,5.24,5.24,0,0,1,2.08-4,6.93,6.93,0,0,1,2.25-1l-.11-.44a7.32,7.32,0,0,0-2.41,1.09,5.66,5.66,0,0,0-2.27,4.41,6.92,6.92,0,0,0,1.31,3.84c.67.83,2.36,2.58,2.36,2.58a.21.21,0,0,1,.07.15.17.17,0,0,1,0,.1l.4.23A.73.73,0,0,0,571.28,372.15Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-117",
  d: "M575.78,365.7h-.06l-.07,0a.6.6,0,0,0-.4.39l.44.13h0a.14.14,0,0,1,.09-.08h8.94l.46-.46Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-118",
  points: "610.22 376.44 610.84 376.9 608.57 369.53 608.57 371.08 610.22 376.44"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-119",
  points: "604.88 381.24 605.22 381.7 611.8 381.7 612.13 381.24 604.88 381.24"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-120",
  points: "584.72 371.44 584.72 384.49 585.18 384.04 585.18 370.98 584.72 371.44"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-121",
  points: "591.14 384.04 585.18 384.04 584.72 384.49 591.59 384.49 591.14 384.04"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-122",
  points: "591.14 371.01 591.14 384.04 591.59 384.49 591.59 371.47 591.14 371.01"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-123",
  points: "599.48 371.01 591.14 371.01 591.59 371.47 599.94 371.47 599.48 371.01"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-124",
  points: "599.48 365.63 599.48 371.01 599.94 371.47 599.94 365.17 599.48 365.63"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-125",
  d: "M603,359.89s-5.84,19.3-5.84,19.33l.61-.46,5.57-18.41Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-126",
  points: "604.01 384.04 597.8 384.04 597.19 384.49 604.34 384.49 604.01 384.04"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-127",
  points: "604.88 381.24 604.01 384.04 604.34 384.49 605.22 381.7 604.88 381.24"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-128",
  points: "612.13 381.24 611.8 381.7 612.68 384.5 613.02 384.04 612.13 381.24"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-129",
  points: "619.11 384.04 613.02 384.04 612.68 384.5 619.73 384.49 619.11 384.04"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-130",
  points: "628.14 384.04 621.41 384.04 620.95 384.5 628.59 384.49 628.14 384.04"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-131",
  points: "628.67 370.64 628.22 370.18 628.22 373.54 628.68 373.08 628.67 370.64"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-132",
  points: "647.44 378.11 647.44 384.04 647.9 384.49 647.9 377.65 647.44 378.11"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-133",
  d: "M647.44,378.76H636.35a5.46,5.46,0,0,1-3.37-1.32l-4.06-4.07-.78-.79.45,1.11,4.06,4.07a6,6,0,0,0,3.69,1.46H647.9Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-134",
  points: "613.74 365.17 613.4 365.63 619.11 384.04 619.73 384.49 613.74 365.17"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-135",
  points: "621.41 365.63 620.95 365.17 620.95 384.5 621.41 384.04 621.41 365.63"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-136",
  points: "606.3 376.9 606.92 376.44 608.57 371.08 608.57 369.53 606.3 376.9"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-137",
  points: "610.22 376.44 606.92 376.44 606.3 376.9 610.84 376.9 610.22 376.44"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-138",
  points: "628.14 377.86 628.14 384.04 628.59 384.49 628.59 378.97 628.14 377.86"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-139",
  d: "M638.57,372.38h-.16c-.8,0-1-.31-1.06-.45h-.47a1,1,0,0,0,.75.79,2.9,2.9,0,0,0,.94.13h8.87l.46-.45Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-140",
  d: "M573.05,359.89l-.3,0a5.17,5.17,0,0,0-1,.17l.11.44a4.92,4.92,0,0,1,1.08-.17h26.52l.46-.46Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-141",
  d: "M570.8,372.25a.24.24,0,0,1-.21.14H555.15l.46.45h15a.69.69,0,0,0,.61-.36Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-142",
  d: "M578.13,369.08c-.29-.36-1.24-1.37-1.87-2l-.53-.55a.21.21,0,0,1-.07-.15.19.19,0,0,1,0-.1h0l-.44-.13a.59.59,0,0,0,0,.23.64.64,0,0,0,.21.47l.55.59c.61.64,1.53,1.62,1.82,2l.05.06a5.54,5.54,0,0,1-4.12,9.33v.46a6.08,6.08,0,0,0,4.42-10.14Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-143",
  points: "620.95 365.17 621.41 365.63 634.45 365.63 634.46 365.17 620.95 365.17"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-144"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-145",
  points: "555.61 378.12 555.15 377.67 555.15 384.49 555.61 384.04 555.61 378.12"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-146",
  points: "562.61 386.38 562.95 385.92 555.11 385.92 555.73 386.38 562.61 386.38"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-147",
  points: "598.16 386.38 598.5 385.92 587.79 385.93 588.13 386.38 598.16 386.38"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-148",
  points: "583.91 386.38 584.52 385.93 577.2 385.93 577.53 386.38 583.91 386.38"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-149",
  points: "573.65 386.38 573.99 385.93 565.98 385.92 566.33 386.38 573.65 386.38"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-150"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-151",
  points: "569.88 396.26 569.87 397.82 572.11 405.25 572.45 404.79 569.88 396.26"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-152",
  points: "593.33 390.28 593.33 391.83 594.98 397.2 595.6 397.65 593.33 390.28"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-153",
  d: "M617.86,385.66v.46h0a1.24,1.24,0,0,1,1.27,1.26,1.19,1.19,0,0,1-1,1.18l.06.45a1.62,1.62,0,0,0,1.4-1.63A1.69,1.69,0,0,0,617.86,385.66Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-154",
  d: "M619.57,381.11a7.08,7.08,0,0,1,4.06,1.6,5.31,5.31,0,0,1,1.92,4.28,5,5,0,0,1-1.92,4.17,9.8,9.8,0,0,1-1.23.84h0a.7.7,0,0,0-.39.6.4.4,0,0,0,0,.13h.48a.34.34,0,0,1,0-.13c0-.12.14-.19.14-.19a11.38,11.38,0,0,0,1.31-.9A5.54,5.54,0,0,0,626,387a5.78,5.78,0,0,0-2.08-4.63,7.58,7.58,0,0,0-4.35-1.71H606.07l.46.46Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-155",
  points: "589.64 402 589.98 402.45 596.55 402.45 596.88 401.99 589.64 402"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-156",
  points: "555.87 386.85 555.73 386.38 555.11 385.92 561.09 405.25 561.42 404.79 555.87 386.85"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-157",
  points: "565.98 385.92 564.52 391.18 564.53 392.83 566.33 386.38 565.98 385.92"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-158",
  points: "564.52 391.18 562.95 385.92 562.61 386.38 564.53 392.83 564.52 391.18"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-159",
  points: "575.62 391.18 573.99 385.93 573.65 386.38 575.63 392.73 575.62 391.18"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-160",
  d: "M577.2,380.65l-1.58,5.25v1.55s1.84-6.12,1.9-6.35Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-161",
  d: "M583.91,381.1l-5.6,18.41.34.46,5.87-19.32Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-162",
  d: "M587.79,380.65S582,399.94,582,400l.61-.46c.72-2.4,5.5-18.17,5.57-18.41Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-163",
  points: "598.5 385.92 598.16 386.38 603.87 404.79 604.49 405.25 598.5 385.92"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-164",
  points: "591.06 397.65 591.68 397.2 593.33 391.83 593.33 390.28 591.06 397.65"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-165",
  points: "594.98 397.2 591.68 397.2 591.06 397.65 595.6 397.65 594.98 397.2"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-166",
  points: "606.53 386.38 606.07 385.93 606.07 405.25 606.53 404.79 606.53 386.38"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-167",
  points: "613.33 390.93 613.33 394.29 613.79 393.84 613.79 391.39 613.33 390.93"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-168",
  points: "613.25 398.61 613.25 404.79 613.71 405.25 613.71 399.72 613.25 398.61"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-169",
  points: "613.25 404.79 606.53 404.79 606.07 405.25 613.71 405.25 613.25 404.79"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-170",
  points: "596.88 401.99 596.55 402.45 597.44 405.25 597.78 404.79 596.88 401.99"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-171",
  points: "567.23 404.79 561.42 404.79 561.09 405.25 567.57 405.25 567.23 404.79"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-172",
  d: "M567.23,399.51l.33.46,2.31-7.43V391Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-173",
  points: "578.31 404.79 572.45 404.79 572.11 405.25 578.65 405.25 578.31 404.79"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-174",
  points: "588.77 404.79 582.56 404.79 581.95 405.25 589.1 405.25 588.77 404.79"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-175",
  points: "589.64 402 588.77 404.79 589.1 405.25 589.98 402.45 589.64 402"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-176",
  points: "603.87 404.79 597.78 404.79 597.44 405.25 604.49 405.25 603.87 404.79"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-177",
  points: "647.44 386.38 647.44 391.73 647.9 392.19 647.9 385.92 647.44 386.38"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-178",
  points: "618.12 393.84 613.79 393.84 613.33 394.29 618.12 394.29 618.15 394.29 618.18 394.29 618.12 393.84"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-179",
  d: "M613.33,385.66l.46.45h4.07v-.46Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-180",
  d: "M633.38,393h0a.24.24,0,0,1-.22.16h-9.47c-.83,0-1.1-.24-1.19-.4H622c.05.24.28.73,1.28.83.12,0,.25,0,.39,0h9.47a.69.69,0,0,0,.63-.43Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-181",
  points: "614.03 399.4 613.25 398.61 613.71 399.72 617.77 403.79 618.09 403.47 614.03 399.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-182",
  d: "M621.47,399.51a6.19,6.19,0,0,1-2.14-.5,3.94,3.94,0,0,1-1.24-.82l-.32.33a4.27,4.27,0,0,0,1.25.85,6.83,6.83,0,0,0,2.45.6h14.8v-.46Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-183",
  d: "M638.25,387a.2.2,0,0,1,.1-.08h9.55l-.46-.45h-9.22a.66.66,0,0,0-.38.31l.41.21Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-184",
  d: "M640.7,389.85c-.19-.23-.65-.73-1.12-1.24s-1.1-1.18-1.29-1.37a.19.19,0,0,1-.07-.14.45.45,0,0,1,0-.11h0l-.41-.21a.83.83,0,0,0-.07.32.61.61,0,0,0,.21.47l1.35,1.44c.43.47.84.92,1,1.13l0,.06a5.5,5.5,0,0,1,1.39,3.81,5.37,5.37,0,0,1-5.52,5.5V400a6.07,6.07,0,0,0,4.43-10.12Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-185",
  d: "M635.62,380.65a7.27,7.27,0,0,0-3.7,1.27,5.71,5.71,0,0,0-2.26,4.42,6.91,6.91,0,0,0,1.31,3.83c.67.83,2.36,2.57,2.36,2.57a.2.2,0,0,1,.06.15.22.22,0,0,1,0,.08h0l.41.19a.6.6,0,0,0,.06-.27.64.64,0,0,0-.18-.45h0s-1.68-1.72-2.34-2.53a6.52,6.52,0,0,1-1.21-3.55,5.24,5.24,0,0,1,2.09-4,6.81,6.81,0,0,1,3.42-1.19v-.45Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-186",
  points: "635.63 385.92 635.62 386.38 647.44 386.38 647.9 385.92 635.63 385.92"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-150"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-187",
  d: "M632.75,364.91l0,.45h0a1.25,1.25,0,0,1,1.31,1.26,1.18,1.18,0,0,1-1,1.18l.07.46a1.63,1.63,0,0,0,1.4-1.64A1.68,1.68,0,0,0,632.75,364.91Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-188",
  d: "M571.28,372.15a.73.73,0,0,0-.17-.46h0s-1.68-1.74-2.33-2.54a6.53,6.53,0,0,1-1.21-3.56,5.24,5.24,0,0,1,2.08-4,6.93,6.93,0,0,1,2.25-1l-.11-.44a7.32,7.32,0,0,0-2.41,1.09,5.66,5.66,0,0,0-2.27,4.41,6.92,6.92,0,0,0,1.31,3.84c.67.83,2.36,2.58,2.36,2.58a.21.21,0,0,1,.07.15.17.17,0,0,1,0,.1l.4.23A.73.73,0,0,0,571.28,372.15Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-189",
  d: "M575.78,365.7h-.06l-.07,0a.6.6,0,0,0-.4.39l.44.13h0a.14.14,0,0,1,.09-.08h8.94l.46-.46Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-190",
  points: "610.22 376.44 610.84 376.9 608.57 369.53 608.57 371.08 610.22 376.44"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-191",
  points: "613.4 365.63 613.74 365.17 603.03 365.17 603.37 365.63 613.4 365.63"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-192",
  points: "604.88 381.24 605.22 381.7 611.8 381.7 612.13 381.24 604.88 381.24"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-193",
  points: "584.72 371.44 584.72 384.49 585.18 384.04 585.18 370.98 584.72 371.44"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-194",
  points: "591.14 384.04 585.18 384.04 584.72 384.49 591.59 384.49 591.14 384.04"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-195",
  points: "591.14 371.01 591.14 384.04 591.59 384.49 591.59 371.47 591.14 371.01"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-196",
  points: "599.48 371.01 591.14 371.01 591.59 371.47 599.94 371.47 599.48 371.01"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-197",
  points: "599.48 365.63 599.48 371.01 599.94 371.47 599.94 365.17 599.48 365.63"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-198",
  d: "M603,359.89s-5.84,19.3-5.84,19.33l.61-.46,5.57-18.41Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-199",
  points: "604.01 384.04 597.8 384.04 597.19 384.49 604.34 384.49 604.01 384.04"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-200",
  points: "604.88 381.24 604.01 384.04 604.34 384.49 605.22 381.7 604.88 381.24"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-201",
  points: "612.13 381.24 611.8 381.7 612.68 384.5 613.02 384.04 612.13 381.24"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-202",
  points: "619.11 384.04 613.02 384.04 612.68 384.5 619.73 384.49 619.11 384.04"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-203",
  points: "628.14 384.04 621.41 384.04 620.95 384.5 628.59 384.49 628.14 384.04"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-204",
  points: "628.67 370.64 628.22 370.18 628.22 373.54 628.68 373.08 628.67 370.64"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-205",
  points: "647.44 378.11 647.44 384.04 647.9 384.49 647.9 377.65 647.44 378.11"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-206",
  d: "M647.44,378.76H636.35a5.46,5.46,0,0,1-3.37-1.32l-4.06-4.07-.78-.79.45,1.11,4.06,4.07a6,6,0,0,0,3.69,1.46H647.9Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-207",
  points: "613.74 365.17 613.4 365.63 619.11 384.04 619.73 384.49 613.74 365.17"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-208",
  points: "621.41 365.63 620.95 365.17 620.95 384.5 621.41 384.04 621.41 365.63"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-209",
  points: "606.3 376.9 606.92 376.44 608.57 371.08 608.57 369.53 606.3 376.9"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-210",
  points: "610.22 376.44 606.92 376.44 606.3 376.9 610.84 376.9 610.22 376.44"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-211",
  points: "628.14 377.86 628.14 384.04 628.59 384.49 628.59 378.97 628.14 377.86"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-212",
  d: "M638.57,372.38h-.16c-.8,0-1-.31-1.06-.45h-.47a1,1,0,0,0,.75.79,2.9,2.9,0,0,0,.94.13h8.87l.46-.45Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-213",
  d: "M573.05,359.89l-.3,0a5.17,5.17,0,0,0-1,.17l.11.44a4.92,4.92,0,0,1,1.08-.17h26.52l.46-.46Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-214",
  d: "M570.8,372.25a.24.24,0,0,1-.21.14H555.15l.46.45h15a.69.69,0,0,0,.61-.36Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-215",
  points: "633 373.08 628.68 373.08 628.22 373.54 633 373.54 633.04 373.54 633.07 373.54 633 373.08"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-216",
  d: "M628.21,364.9l.46.46h4l0-.45Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-217",
  d: "M578.13,369.08c-.29-.36-1.24-1.37-1.87-2l-.53-.55a.21.21,0,0,1-.07-.15.19.19,0,0,1,0-.1h0l-.44-.13a.59.59,0,0,0,0,.23.64.64,0,0,0,.21.47l.55.59c.61.64,1.53,1.62,1.82,2l.05.06a5.54,5.54,0,0,1-4.12,9.33v.46a6.08,6.08,0,0,0,4.42-10.14Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-218",
  points: "555.61 384.04 555.15 384.49 573.71 384.49 573.71 384.04 555.61 384.04"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-219",
  d: "M638.81,361.61a7.55,7.55,0,0,0-4.35-1.72v.46a7.12,7.12,0,0,1,4.06,1.6,5.32,5.32,0,0,1,1.92,4.29,5.07,5.07,0,0,1-1.92,4.16,11,11,0,0,1-1.23.85h0a.68.68,0,0,0-.39.6v.06h.47a.23.23,0,0,1,0-.07c0-.12.14-.19.14-.19a11.38,11.38,0,0,0,1.31-.9,5.52,5.52,0,0,0,2.09-4.52A5.79,5.79,0,0,0,638.81,361.61Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-220",
  points: "620.95 365.17 621.41 365.63 634.45 365.63 634.46 365.17 620.95 365.17"
}))), /*#__PURE__*/React.createElement("g", {
  className: "cls-115"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-4",
  points: "585.18 384.04 584.72 384.49 591.59 384.49 591.14 384.04 585.18 384.04"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-4",
  points: "604.01 384.04 597.8 384.04 597.19 384.49 604.34 384.49 604.01 384.04"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-4",
  points: "619.11 384.04 613.02 384.04 612.68 384.5 619.73 384.49 619.11 384.04"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-4",
  points: "628.14 384.04 621.41 384.04 620.95 384.5 628.59 384.49 628.14 384.04"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M635.77,378.76a6.56,6.56,0,0,1-3-.93,6.07,6.07,0,0,0,3.62,1.39H647.9l-.46-.46H635.77Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M573.73,378.76H555.61l-.46.46h18.56a6,6,0,0,0,4.22-1.67,6,6,0,0,1-3.69,1.21Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-4",
  points: "555.73 386.38 562.61 386.38 562.95 385.92 555.11 385.92 555.73 386.38"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-4",
  points: "588.13 386.38 598.16 386.38 598.5 385.92 587.79 385.93 588.13 386.38"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-4",
  points: "577.53 386.38 583.91 386.38 584.52 385.93 577.2 385.93 577.53 386.38"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-4",
  points: "566.33 386.38 573.65 386.38 573.99 385.93 565.98 385.92 566.33 386.38"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M647.44,381.1l.46-.45H635.62a7.27,7.27,0,0,0-3.7,1.27,6.45,6.45,0,0,0-.83.78,4.73,4.73,0,0,1,.38-.31,7.16,7.16,0,0,1,3.69-1.28h12.28Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M623.93,382.36h0a7.58,7.58,0,0,0-4.35-1.71H606.07l.46.46h13.66A7.68,7.68,0,0,1,623.93,382.36Z",
  transform: "translate(0 5.28)"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-221"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-222",
  points: "606.53 404.79 606.07 405.25 613.71 405.25 613.25 404.79 606.53 404.79"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-223",
  points: "561.42 404.79 561.09 405.25 567.57 405.25 567.23 404.79 561.42 404.79"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-224",
  points: "572.45 404.79 572.11 405.25 578.65 405.25 578.31 404.79 572.45 404.79"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-225",
  points: "582.56 404.79 581.95 405.25 589.1 405.25 588.77 404.79 582.56 404.79"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-226",
  points: "597.78 404.79 597.44 405.25 604.49 405.25 603.87 404.79 597.78 404.79"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-227",
  d: "M622.13,399.51h-1.37a6.7,6.7,0,0,1-2.45-.59l-.2-.1a4.33,4.33,0,0,0,.91.55,6.83,6.83,0,0,0,2.45.6h14.8a6,6,0,0,0,3.78-1.28,6,6,0,0,1-3.11.82Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-228",
  points: "603.37 365.63 613.4 365.63 613.74 365.17 603.03 365.17 603.37 365.63"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-229",
  d: "M599.48,360.35l.46-.46H573.05l-.3,0a5.17,5.17,0,0,0-1,.17,7.32,7.32,0,0,0-2.41,1.09,6,6,0,0,0-.81.75,3.05,3.05,0,0,1,.36-.29,7.23,7.23,0,0,1,2.41-1.1,7.34,7.34,0,0,1,1-.17h27.19Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-230",
  d: "M638.75,361.56a7.57,7.57,0,0,0-4.29-1.67H621l.46.46h13.66A7.69,7.69,0,0,1,638.75,361.56Z",
  transform: "translate(0 5.28)"
})), /*#__PURE__*/React.createElement("path", {
  className: "cls-231",
  d: "M598,381.33l5.56,18h-5.62L597.2,397l-.1-.32,0-.05,0-.1h-7.58l0,.11,0,0-.1.32-.72,2.31h-5.73c.81-2.7,3.4-11.27,5.43-18H598m-7.25,11.27h5.16l-.06-.19,0-.1-.18-.59L594,386.36l-.44-1.42-.07-.24-.15-.47-.14.47-.08.24-.43,1.42L591,391.72l-.18.59,0,.1-.06.19m7.36-11.42h-9.92l-5.53,18.26h6.05l.76-2.42.1-.32,0-.06h7.35v.05l.11.32.77,2.43h5.93l-5.65-18.26ZM591,392.45l0-.1.18-.59,1.65-5.36.44-1.42.07-.23.07.23.44,1.42,1.65,5.36.18.59,0,.1H591Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-232",
  d: "M599.25,360.58v4.93h-8.34v13h-5.5V365.47h-9.76l-.07,0a.87.87,0,0,0-.61.84.84.84,0,0,0,.28.63c.11.13,1.94,2,2.36,2.55l0,.05a5.32,5.32,0,0,1-3.94,9H555.84v-5.46h14.75a.92.92,0,0,0,.69-1.53h0c-.07-.07-1.69-1.74-2.32-2.52a6.24,6.24,0,0,1-1.16-3.42,5,5,0,0,1,2-3.86,6.48,6.48,0,0,1,3.28-1.14h26.2m.16-.16H573.05a6.66,6.66,0,0,0-3.37,1.18,5.12,5.12,0,0,0-2.06,4,6.38,6.38,0,0,0,1.2,3.51c.64.79,2.26,2.46,2.33,2.54h0a.78.78,0,0,1,.2.51.76.76,0,0,1-.77.77H555.68v5.76h18a5.54,5.54,0,0,0,4.06-9.2l0-.06c-.44-.52-2.3-2.47-2.38-2.55a.75.75,0,0,1-.22-.53.71.71,0,0,1,.5-.69l.06,0h9.56v13.05h5.81v-13h8.35v-5.24Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-233",
  d: "M562.44,381.33l1.42,4.77.45,1.52.08.25.15.5.14-.5.07-.26.43-1.52,1.32-4.76h7l1.49,4.78.44,1.41.07.23.15.47.14-.47.07-.24.44-1.41s0-.12.09-.31l.2-.65.5-1.67,0-.11c.3-1,.49-1.65.6-2h5.9c-1,3.25-4.37,14.38-5.46,17.95h-5.52l-2.1-6.93-.43-1.43-.07-.24-.14-.48-.15.48-.07.24-.45,1.42-1.15,3.71c-.55,1.79-.84,2.73-1,3.23h-5.47L556,381.33h6.4m.11-.15h-6.72l5.65,18.26h5.7c.14-.49.45-1.46,1-3.34l1.15-3.71.44-1.43.08-.24.07.24.43,1.43,2.12,7.05h5.75c.78-2.55,4.62-15.16,5.56-18.26h-6.22l-.64,2.14,0,.11-.5,1.66c-.16.54-.28,1-.29,1l-.43,1.41-.07.24-.08-.24-.44-1.41-1.52-4.88h-7.2L565,386.05l-.42,1.52-.07.26-.08-.26-.45-1.51-1.46-4.88Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-234",
  d: "M613.24,360.58l5.56,17.95h-5.62l-.73-2.31-.1-.32,0-.06,0-.1h-7.59l0,.1,0,.06-.1.32-.72,2.31h-5.73c.89-2.95,3.8-12.55,5.43-17.95h9.7M606,371.85h5.16l-.06-.2,0-.1-.18-.59-1.66-5.36-.43-1.42-.08-.23-.14-.48-.15.48-.07.23-.44,1.42L606.26,371l-.18.59,0,.1-.06.2m7.36-11.43h-9.92c-1.57,5.18-4.7,15.5-5.53,18.25H604l.76-2.42.1-.32,0-.05h7.36l0,.05.1.32.76,2.42H619l-5.65-18.26ZM606.2,371.7l0-.1.18-.59,1.65-5.37.44-1.41.07-.24.07.24.44,1.41,1.65,5.37.18.59,0,.1H606.2Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-235",
  d: "M634.45,360.58a6.93,6.93,0,0,1,3.91,1.54,5.11,5.11,0,0,1,1.84,4.12,4.83,4.83,0,0,1-1.83,4,9.86,9.86,0,0,1-1.19.82h0a.9.9,0,0,0-.52.8c0,.12.05,1.2,1.92,1.21h8.65v5.47H636.36a5.27,5.27,0,0,1-3.22-1.25l-4.06-4.08-.78-.78-.13-.13-.26-.26v6.5h-6.27V360.58h12.81M628,368.49h5.11a1.85,1.85,0,0,0,1.6-1.86,1.91,1.91,0,0,0-2.05-1.95H628v3.82m6.46-8.07h-13v18.26h6.57V372.4l.13.13.78.78,4.06,4.08a5.47,5.47,0,0,0,3.32,1.29h11v-5.77h-8.8c-1.72,0-1.77-1-1.77-1.06a.78.78,0,0,1,.44-.67h0a10.3,10.3,0,0,0,1.21-.84,5,5,0,0,0,1.89-4.1,5.23,5.23,0,0,0-1.89-4.23,7.18,7.18,0,0,0-4-1.59Zm-6.3,7.92v-3.51h4.51a1.77,1.77,0,0,1,1.89,1.79,1.69,1.69,0,0,1-1.46,1.71h-4.93Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-236",
  d: "M647.22,381.33v4.9h-9.06a.88.88,0,0,0-.35,1.48c.34.35,2,2.08,2.36,2.56l.05,0a5.55,5.55,0,0,1-.12,7.39,5.33,5.33,0,0,1-3.83,1.55H621.48a5.29,5.29,0,0,1-3.22-1.25L614.19,394l-.78-.79-.13-.13-.26-.26v6.5h-6.26V381.33h12.81a6.87,6.87,0,0,1,3.91,1.55,5.09,5.09,0,0,1,1.84,4.11,4.82,4.82,0,0,1-1.83,4,11.17,11.17,0,0,1-1.19.82h0a.93.93,0,0,0-.52.8c0,.12.06,1.21,1.92,1.21h9.47a.92.92,0,0,0,.92-.92.94.94,0,0,0-.24-.61h0s-1.68-1.72-2.31-2.51a6.21,6.21,0,0,1-1.17-3.41,5,5,0,0,1,2-3.87,6.52,6.52,0,0,1,3.29-1.14h11.6m-34.12,7.91h5.12a1.85,1.85,0,0,0,1.59-1.86,1.92,1.92,0,0,0-2-1.95H613.1v3.81m34.27-8.06H635.62a6.77,6.77,0,0,0-3.38,1.17,5.2,5.2,0,0,0-2,4,6.33,6.33,0,0,0,1.2,3.5c.63.79,2.25,2.46,2.32,2.53h0a.83.83,0,0,1,.19.51.76.76,0,0,1-.76.77h-9.47c-1.71,0-1.76-1-1.76-1.06a.74.74,0,0,1,.43-.66h0a10.26,10.26,0,0,0,1.21-.83,5,5,0,0,0,1.9-4.11,5.24,5.24,0,0,0-1.9-4.23,7.05,7.05,0,0,0-4-1.58h-13v18.26h6.57v-6.29l.13.13.78.78,4.06,4.08a5.56,5.56,0,0,0,3.33,1.3h14.79a5.33,5.33,0,0,0,5.45-5.43,5.37,5.37,0,0,0-1.38-3.76l-.05-.06c-.39-.47-1.91-2.09-2.37-2.57a.72.72,0,0,1,.28-1.22l.06,0h9.11v-5.2Zm-34.11,7.91v-3.51h4.51a1.77,1.77,0,0,1,1.89,1.8,1.71,1.71,0,0,1-1.46,1.71h-4.94Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-237",
  d: "M598.11,381.18l5.65,18.26h-5.93l-.77-2.43-.11-.32v-.05h-7.35l0,.06-.1.32-.76,2.42h-6.05l5.53-18.26h9.92M591,392.45h4.74l0-.1-.18-.59-1.65-5.36L593.4,385l-.07-.23-.07.23-.44,1.42-1.65,5.36-.18.59,0,.1m7.2-11.35h-10c-1.77,5.84-4.81,15.91-5.57,18.41h6.21l.77-2.47.1-.32h7.24l.1.32.8,2.49h6.09l-5.71-18.42Zm-7.1,11.28.18-.59,1.65-5.37.44-1.41.44,1.41,1.65,5.37.18.59h-4.54Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-237",
  d: "M647.37,381.18v5.2h-9.11l-.06,0a.72.72,0,0,0-.28,1.22c.46.48,2,2.1,2.37,2.57l.05.06a5.37,5.37,0,0,1,1.38,3.76,5.33,5.33,0,0,1-5.45,5.43H621.48a5.56,5.56,0,0,1-3.33-1.3l-4.06-4.08-.78-.78-.13-.13v6.29h-6.57V381.18h13a7.05,7.05,0,0,1,4,1.58,5.24,5.24,0,0,1,1.9,4.23,5,5,0,0,1-1.9,4.11,10.26,10.26,0,0,1-1.21.83h0a.74.74,0,0,0-.43.66c0,.11.05,1,1.76,1.06h9.47a.76.76,0,0,0,.76-.77.83.83,0,0,0-.19-.51h0c-.07-.07-1.69-1.74-2.32-2.53a6.33,6.33,0,0,1-1.2-3.5,5.2,5.2,0,0,1,2-4,6.77,6.77,0,0,1,3.38-1.17h11.75m-34.11,7.91h4.94a1.71,1.71,0,0,0,1.46-1.71,1.77,1.77,0,0,0-1.89-1.8h-4.51v3.51m34.18-8H635.62a6.81,6.81,0,0,0-3.42,1.19,5.24,5.24,0,0,0-2.09,4,6.52,6.52,0,0,0,1.21,3.55c.66.81,2.32,2.51,2.34,2.53h0a.64.64,0,0,1,.18.45.7.7,0,0,1-.69.7h-9.47c-1.64,0-1.69-.89-1.69-1a.7.7,0,0,1,.39-.6h0a9.8,9.8,0,0,0,1.23-.84,5,5,0,0,0,1.92-4.17,5.31,5.31,0,0,0-1.92-4.28,7.08,7.08,0,0,0-4.06-1.6h-13v18.4h6.72v-6.17l.78.78,4.06,4.07a5.55,5.55,0,0,0,3.38,1.32h14.8a5.37,5.37,0,0,0,5.52-5.5,5.5,5.5,0,0,0-1.39-3.81l0-.06c-.39-.46-1.9-2.07-2.37-2.57a.61.61,0,0,1-.21-.47.64.64,0,0,1,.45-.63h9.22V381.1ZM613.33,389v-3.36h4.44a1.69,1.69,0,0,1,1.81,1.72,1.62,1.62,0,0,1-1.4,1.63h-4.85Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-237",
  d: "M613.35,360.42,619,378.68h-5.93l-.76-2.42-.1-.32,0-.05h-7.36l0,.05-.1.32-.76,2.42H597.9c.83-2.75,4-13.07,5.53-18.25h9.92M606.2,371.7h4.74l0-.1-.18-.59-1.65-5.37-.44-1.41-.07-.24-.07.24-.44,1.41L606.41,371l-.18.59,0,.1m7.2-11.35h-10c-1.77,5.84-4.82,15.9-5.57,18.41H604l.77-2.47.1-.33h7.25l.1.32.79,2.48h6.09l-5.71-18.41Zm-7.1,11.27.18-.59,1.65-5.36.44-1.42.44,1.42,1.65,5.36.18.59H606.3Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-237",
  d: "M562.55,381.18l1.46,4.88.45,1.51.08.26.07-.26.42-1.52,1.36-4.87h7.2l1.52,4.88.44,1.41.08.24.07-.24.43-1.41s.13-.43.29-1l.5-1.66,0-.11.64-2.14h6.22c-.94,3.1-4.78,15.71-5.56,18.26H572.5l-2.12-7.05L570,391l-.07-.24-.08.24-.44,1.43-1.15,3.71c-.58,1.88-.89,2.85-1,3.34h-5.7l-5.65-18.26h6.72m.06-.08h-6.88l5.69,18.41h5.81l1-3.39,1.15-3.71.44-1.43.44,1.43,2.14,7.1h5.86c.68-2.24,4.71-15.46,5.6-18.41h-6.38c-.1.37-.3,1-.68,2.31-.3,1-.79,2.62-.79,2.63l-.43,1.41-.44-1.41-1.54-4.94h-7.32L565,386l-.43,1.52-.45-1.52-1.47-4.93Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-237",
  d: "M634.45,360.42a7.18,7.18,0,0,1,4,1.59,5.23,5.23,0,0,1,1.89,4.23,5,5,0,0,1-1.89,4.1,10.3,10.3,0,0,1-1.21.84h0a.78.78,0,0,0-.44.67c0,.11.05,1,1.77,1.06h8.8v5.77h-11a5.47,5.47,0,0,1-3.32-1.29L629,373.31l-.78-.78-.13-.13v6.28h-6.57V360.42h13m-6.3,7.92h4.93a1.69,1.69,0,0,0,1.46-1.71,1.77,1.77,0,0,0-1.89-1.79h-4.51v3.51m6.3-8h-13v18.41h6.73v-6.18l.78.79,4.06,4.07a5.46,5.46,0,0,0,3.37,1.32h11.09v-5.93h-8.87c-1.64,0-1.69-.88-1.69-1a.68.68,0,0,1,.39-.6h0a11,11,0,0,0,1.23-.85,5.07,5.07,0,0,0,1.92-4.16,5.32,5.32,0,0,0-1.92-4.29,7.12,7.12,0,0,0-4.06-1.6Zm-6.23,7.91V364.9h4.44a1.7,1.7,0,0,1,1.82,1.72,1.63,1.63,0,0,1-1.4,1.64h-4.85Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-237",
  d: "M599.41,360.42v5.24h-8.35v13h-5.81V365.63h-9.56l-.06,0a.71.71,0,0,0-.5.69.75.75,0,0,0,.22.53c.08.08,1.94,2,2.38,2.55l0,.06a5.46,5.46,0,0,1-4.06,9.2h-18v-5.76h14.91a.76.76,0,0,0,.77-.77.78.78,0,0,0-.2-.51h0c-.07-.08-1.69-1.75-2.33-2.54a6.38,6.38,0,0,1-1.2-3.51,5.12,5.12,0,0,1,2.06-4,6.66,6.66,0,0,1,3.37-1.18h26.36m.07-.07H573.05a6.75,6.75,0,0,0-3.42,1.19,5.24,5.24,0,0,0-2.08,4,6.53,6.53,0,0,0,1.21,3.56c.65.8,2.32,2.52,2.33,2.54h0a.73.73,0,0,1,.17.46.69.69,0,0,1-.69.69h-15v5.92h18.1a5.62,5.62,0,0,0,4.12-9.33l-.05-.06c-.42-.51-2.2-2.38-2.37-2.56a.64.64,0,0,1-.21-.47.64.64,0,0,1,.45-.62l.07,0h9.46v13.06h6v-13h8.34v-5.38Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M701.3,377.77H688.83a97.69,97.69,0,0,0-1.57-12.63.92.92,0,0,0-.91-.76h-2.87a.86.86,0,0,0-.65.31.81.81,0,0,0-.18.7,93.34,93.34,0,0,1,1.59,12.38h-12a1,1,0,0,0-1,1v2.59a1,1,0,0,0,1,1h12.17c0,.64,0,1.21,0,1.75a92.34,92.34,0,0,1-.53,10.29.95.95,0,0,0,.93,1.05h2.67a1,1,0,0,0,1-.91,94.46,94.46,0,0,0,.52-10.43c0-.53,0-1.11,0-1.75h12.3a1,1,0,0,0,1-1v-2.59A1,1,0,0,0,701.3,377.77Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-238",
  d: "M748.77,395.4V364.46H729.54V395.4Zm-23.13,3.9V360.56h27V399.3Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M768.79,374.07h0c-2.15-3.47-4.33-6.53-6.53-9.62h-1.67v13.49h1.85v-9.67h0c2.17,3.49,4.35,6.57,6.55,9.67h1.67V364.45h-1.85Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M782.14,377.94l-4.29-13.49h-1.93l-4.66,13.49h2l1.18-3.68h4.06l1.06,3.68ZM775,372.6c.54-1.77,1.08-3.41,1.56-5.49h0c.54,2.08,1,3.72,1.52,5.49Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-4",
  points: "784.32 383.22 786.63 383.22 786.63 371.54 790.17 371.54 790.17 369.73 780.77 369.73 780.77 371.54 784.32 371.54 784.32 383.22"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-4",
  x: 790.93,
  y: 369.73,
  width: 2.29,
  height: 13.49
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M800.35,378.17c3.52,0,5.72-3.14,5.72-7.16,0-3.78-2.43-6.79-5.72-6.79s-5.73,3-5.73,6.79C794.62,375,796.82,378.17,800.35,378.17Zm0-12c2.29,0,3.25,2.37,3.25,4.86s-.85,5.23-3.25,5.23-3.26-2.65-3.26-5.23S798.05,366.15,800.35,366.15Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M809.32,368.27h0c2.18,3.49,4.36,6.57,6.55,9.67h1.68V364.45h-1.85v9.62h0c-2.16-3.47-4.33-6.53-6.53-9.62h-1.68v13.49h1.85Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M821.36,374.26h4.07l1.06,3.68h2.58l-4.3-13.49h-1.92l-4.66,13.49h2Zm2.16-7.15h0c.54,2.08,1,3.72,1.52,5.49H822C822.5,370.83,823,369.19,823.52,367.11Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-4",
  points: "836.6 381.41 832.04 381.41 832.04 369.73 829.74 369.73 829.74 383.22 836.6 383.22 836.6 381.41"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M766.91,393.36a3.38,3.38,0,0,1-1.62.33c-2,0-3.91-1.89-3.91-5.08s1.67-5,4.14-5a5,5,0,0,1,2.47.71l.75-1.6a5.77,5.77,0,0,0-3.28-1c-4,0-6.55,3.22-6.55,6.9,0,4,2.51,7.05,6.47,7.05a10.68,10.68,0,0,0,3.84-.83v-5.57h-2.31Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-4",
  points: "773.63 394.5 777.41 394.5 777.41 392.69 773.63 392.69 773.63 388.99 777.48 388.99 777.48 387.18 771.32 387.18 771.32 400.66 778.18 400.66 778.18 398.85 773.63 398.85 773.63 394.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M784.61,381.67c-3.29,0-5.72,3-5.72,6.78,0,4,2.2,7.17,5.72,7.17s5.72-3.14,5.72-7.17C790.33,384.68,787.91,381.67,784.61,381.67Zm0,12c-2.41,0-3.25-2.66-3.25-5.24s1-4.85,3.25-4.85,3.26,2.37,3.26,4.85S787,393.69,784.61,393.69Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M799.12,393.36a3.44,3.44,0,0,1-1.62.33c-2,0-3.91-1.89-3.91-5.08s1.67-5,4.14-5a5,5,0,0,1,2.47.71l.75-1.6a5.77,5.77,0,0,0-3.28-1c-4,0-6.55,3.22-6.55,6.9,0,4,2.51,7.05,6.48,7.05a10.67,10.67,0,0,0,3.83-.83v-5.57h-2.31Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M811.33,385.79c0-2.62-1.6-3.89-4.18-3.89h-3.6v13.49h2.31V390.3h1l2.18,5.09h2.64L809,389.8A4.54,4.54,0,0,0,811.33,385.79Zm-4.51,2.78-1,.06v-4.92h1a2,2,0,0,1,2.14,2.18A2.38,2.38,0,0,1,806.82,388.57Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M816.42,381.9l-4.67,13.49h2l1.17-3.68H819l1.06,3.68h2.58l-4.3-13.49Zm-.89,8.15c.54-1.77,1.08-3.41,1.56-5.49h0c.54,2.08,1,3.72,1.52,5.49Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M827,381.9h-3.6v13.49h2.31V390.3h1a4.4,4.4,0,0,0,4.43-4.51C831.15,383.17,829.56,381.9,827,381.9Zm-.32,6.67c-.24,0-.81,0-1,.05v-4.91h1a2,2,0,0,1,2.12,2.18A2.38,2.38,0,0,1,826.65,388.57Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-4",
  points: "839.55 392.36 834.76 392.36 834.76 387.18 832.46 387.18 832.46 400.66 834.76 400.66 834.76 394.17 839.55 394.17 839.55 400.66 841.87 400.66 841.87 387.22 839.55 387.22 839.55 392.36"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-4",
  x: 844.08,
  y: 387.18,
  width: 2.29,
  height: 13.48
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M854.46,393.69c-2.23,0-4.12-1.89-4.12-5.08s1.72-5,4.06-5a4.86,4.86,0,0,1,2.38.75l.73-1.64a5.69,5.69,0,0,0-3.11-1c-4,0-6.5,3.22-6.5,6.9,0,4,2.5,7.05,6.47,7.05a5.88,5.88,0,0,0,3-.93l-.63-1.67A4.43,4.43,0,0,1,854.46,393.69Z",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("g", {
  id: "Marvel_Logo",
  "data-name": "Marvel Logo"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Red_Fill",
  "data-name": "Red Fill",
  className: "cls-239",
  x: 376.79,
  y: 364.97,
  width: 100.58,
  height: 40.48
}), /*#__PURE__*/React.createElement("path", {
  id: "Marvel",
  className: "cls-4",
  d: "M461.9,369.13v-6.2H444.66l-2.84,20.7-2.8-20.7H432.8l.7,5.53a9.83,9.83,0,0,0-8.87-5.53h-6.22l0,30.17-4.53-30.17h-8.14L401,394.19V362.93h-7.79l-2.81,17.56-2.74-17.56h-7.8v34H386V380.53l2.8,16.39h3.26l2.75-16.39v16.39h11.84l.72-5.23h4.76l.72,5.23h11.64v-11l1.43-.21,2.94,11.24h6L431,383.74c2-1.46,4.18-5.14,3.59-8.66h0s3.65,21.86,3.65,21.86l7.15,0,4.88-30.81v30.81H461.9V390.8h-5.5V383h5.5V376.8h-5.5v-7.67ZM408.11,386.3l1.69-14.53,1.75,14.53ZM426,379.59a3.34,3.34,0,0,1-1.45.34V369h0c.48,0,4.07.14,4.07,5.41C428.61,377.16,427.39,378.89,426,379.59Zm48.31,11.21v6.11H463v-34h6.09V390.8Z",
  transform: "translate(0 5.28)"
})), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M45.17,371.89a5,5,0,0,0-.41.72,1.61,1.61,0,0,1-.32.36.66.66,0,0,1-.94,0,2.26,2.26,0,0,1-.73-1.6,4.88,4.88,0,0,0,0-.77,5.15,5.15,0,0,0-.66-1.11,4.13,4.13,0,0,1-.45-1.61A5.41,5.41,0,0,1,43.36,364a11.11,11.11,0,0,1,3.79-2.57A7.5,7.5,0,0,1,52,361a3.73,3.73,0,0,1,1.51,1,1,1,0,0,0,.21.24,1.46,1.46,0,0,0,.38.08,3.91,3.91,0,0,1,1.45.69,2.68,2.68,0,0,1,1,1.62,4.45,4.45,0,0,1-1.39,3.74,13.73,13.73,0,0,1-5,3.4,7.86,7.86,0,0,1-3.17.56c-.3,0-.62-.1-.91-.12a4.85,4.85,0,0,1-.76-.2c-.08-.05-.17-.1-.19-.08m3.27-2.38a8.45,8.45,0,0,0,3.6-1.07c1.09-.6,2.7-1.79,2.54-3.19a1.19,1.19,0,0,0-.73-.95,1.67,1.67,0,0,0-1.37,0,3.91,3.91,0,0,0-1.08.46,16.36,16.36,0,0,0-4,3.51c-.22.29-.45.62-.63.84s-.19.26-.18.3a5.57,5.57,0,0,0,1.86.09m-4.51-1.2s.42-.63.78-1.11a20.07,20.07,0,0,1,2.71-2.84l.59-.48s-.5.05-.78.1a5.91,5.91,0,0,0-2.15,1.2c-.81.69-1.7,1.81-1.3,2.81.06.14.15.32.15.32",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M47,374.54c-.43-.08-.68.5-.79.8a18.58,18.58,0,0,0-.65,3.57,49.14,49.14,0,0,0,0,8.93c.15,1,.47,1.62,1.48,1.83a2.63,2.63,0,0,0,1.48-.14,1.4,1.4,0,0,0,.55-.81,12.38,12.38,0,0,0,.07-2.86c0-1-.07-2.07-.11-3.11a48.53,48.53,0,0,0-.63-6.56,2,2,0,0,0-1.14-1.58l-.23-.07",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M43.59,382.85c0,.06-.21.6-.26.73a14.55,14.55,0,0,1-.83,1.63A13.5,13.5,0,0,1,40.18,388c-2.56,2.19-6.51,3.44-9.9,3.84a25.17,25.17,0,0,1-7.38-.21c-.83-.15-2.08-.43-2.08-.43s0,.49,0,.84a3.42,3.42,0,0,1-.21.71,1.13,1.13,0,0,1-.89.63,2.62,2.62,0,0,1-1.52-.07A2.19,2.19,0,0,1,17,391.48c-.11-.67-.22-1.82-.22-1.82l-1.06-.51a27.78,27.78,0,0,1-4.13-2.5c-.34-.26-1.81-1.48-2.14-1.78a12.11,12.11,0,0,1-2.34-2.8,2.65,2.65,0,0,1-.26-2.51c.51-1.26,2.33-2.2,3.58-2.75a30.78,30.78,0,0,1,4.94-1.49c.56-.08,1.42-.23,1.47-.26l.06-.05s.07-1.29.06-1.74.34-3.39.45-4a7.44,7.44,0,0,1,.57-2,.54.54,0,0,1,.73-.06c1.35.83,1.77,3.73,1.87,5.21.06.89.09,2.24.09,2.24s1.55,0,2.51,0a23.1,23.1,0,0,1,2.92.33,20.17,20.17,0,0,1,5,1.41,5,5,0,0,1,2.54,2.55,2.57,2.57,0,0,1-.21,2.42,3.44,3.44,0,0,1-2.64,1.72,4.31,4.31,0,0,1-1.85-.42.3.3,0,0,1,0-.44,8.19,8.19,0,0,1,.91-.51,1.87,1.87,0,0,0,.42-.3c.27-.23.52-.49.49-.8s-.46-.64-.86-.79a32,32,0,0,0-7.47-1.47c-.71,0-1.72-.07-1.72-.07l.21,10s.84.16,1.5.26c.38.06,2,.2,2.41.21a22.32,22.32,0,0,0,9.84-1.59,10.25,10.25,0,0,0,3.42-2.4,6.93,6.93,0,0,0,1.66-5.16c-.18-2.13-1.69-4.65-2.9-6.18-3.18-4.06-8.63-7.4-13.43-9.35a43.21,43.21,0,0,0-14.94-3.34,24.71,24.71,0,0,0-5.74.43c-.21.05-.42.13-.62.17a2.06,2.06,0,0,0-.46.19l-.08.07.18.09c.16.07.82.11,1.16.17a1.12,1.12,0,0,1,.75.44.44.44,0,0,1,0,.55c-.34.4-1.6.33-2.15.25s-1.3-.27-1.43-.77a2.34,2.34,0,0,1,.43-1.69,4.15,4.15,0,0,1,2.77-2,28.91,28.91,0,0,1,5.82-.91,34.43,34.43,0,0,1,11.31,1.66,54.94,54.94,0,0,1,7,2.72,53.58,53.58,0,0,1,5.12,2.85c.41.27,2.83,2,3.2,2.34.79.64,1.81,1.55,2.55,2.28a23.1,23.1,0,0,1,4.09,5.29c.21.41.37.81.64,1.29a13.26,13.26,0,0,1,.56,1.42A9.47,9.47,0,0,1,43.59,382.85Zm-26.85-4.41s-1.48.1-2.5.21a27.67,27.67,0,0,0-5.14,1.06c-.42.15-1.28.5-1.36.93a1.43,1.43,0,0,0,.51,1.16c.18.21,1.2,1.18,1.48,1.42a26.1,26.1,0,0,0,5.41,3.25c.61.25,1.63.61,1.63.61s-.08-2.86-.06-5.68c0-1.49,0-3,0-3",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M60,379.77l-5.5-.64-.16,0c-.24-.05-1.35-.17-1-.59a1.62,1.62,0,0,1,.64-.26c2.49-.68,5.65-.6,8.26-.75a13.64,13.64,0,0,0,2.55-.31,1.74,1.74,0,0,0,1.26-1.29c.07-.35-.1-.52-.44-.7-2.16-1.14-5.73-1.14-7.94-.87s-5.33,1-6.63,2.84a3.49,3.49,0,0,0-.56,2.69,1.86,1.86,0,0,0,1,1.14,6.18,6.18,0,0,0,1.51.37c.49.07,2.56.24,3.87.35a21,21,0,0,1,5,.91c.49.21,1.23.51,1.23,1.14a1.05,1.05,0,0,1-.53.81,12.07,12.07,0,0,1-7,1.72,5.62,5.62,0,0,1-2.3-.48c-.35-.15-.81-.52-.74-.9.13-.76,1-.95,1.66-.88a5.39,5.39,0,0,1,1.28.34c1.52.6,2.22,1.11,3.57.9.5-.07,2.24-.45,2.47-1.16a.49.49,0,0,0-.15-.49,7.87,7.87,0,0,0-1.52-.69,17.32,17.32,0,0,0-4-.73c-1.42,0-3.29.21-4.17,1.4a2.35,2.35,0,0,0-.11,2.56,6.71,6.71,0,0,0,2.83,2.39,10.65,10.65,0,0,0,5.59,1,8.73,8.73,0,0,0,2.95-.8,5.11,5.11,0,0,0,2.38-2.24,5.05,5.05,0,0,0-.11-4.3,3.41,3.41,0,0,0-1.76-1.65,12.9,12.9,0,0,0-3.26-.77l-.16,0",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M67.65,389.59a1.21,1.21,0,0,0,1,.06c.47-.22.6-.64.72-1.16a19.54,19.54,0,0,0,.25-3c0-.11.1-4,.25-4.82,0-.12.05-.29.14-.27a.44.44,0,0,1,.22.17c.23.32,1.67,3.17,2.52,4.63.24.43,1.7,2.92,2.58,3.42a2.41,2.41,0,0,0,2.56-.51,5.12,5.12,0,0,0,1-1.54,11.11,11.11,0,0,0,.58-4.83,17.12,17.12,0,0,0-.84-4c-.13-.39-.69-1.77-.83-2-.41-.8-1.83-3.11-2.9-3.49-.55-.19-.89.09-.89.61a5,5,0,0,0,.17,1.12c.29,1.15.67,2.4,1,3.6a35.63,35.63,0,0,1,.78,3.78c0,.39.08.75.13,1.2,0,.28.09,1.69.07,1.73s-.19.1-.32,0a1.4,1.4,0,0,1-.29-.34c-.76-1.12-1.53-2.35-2.34-3.58s-1.81-2.66-2.63-3.81a1.93,1.93,0,0,0-1.32-.95c-.83-.07-1.22,1.15-1.49,1.89a26.6,26.6,0,0,0-1.52,9.27c0,.85.29,2.54,1.35,2.93",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M81.23,389.54a5.2,5.2,0,0,0,.64.55h0s0,0,0,0",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M81.93,390.14l0,0a0,0,0,0,0,0,0s0,0,0,0a2.78,2.78,0,0,0,.66.3,3.83,3.83,0,0,0,1.83.2,13.89,13.89,0,0,0,5.84-2.53c.47-.35.84-.68.82-1.17a2.11,2.11,0,0,0-.54-1.32c-.39-.49-.77-.44-1.51-.32-1.39.22-3.08.47-4.22.67a4,4,0,0,1-.73.07h-.35s.2-.74.44-1.48.5-1.4.5-1.4l.65-.08c.51-.06,4.24-.08,4.57-.14.64-.1.79-.47.76-1.27s-.24-1.16-.87-1.3a4.86,4.86,0,0,0-.76,0l-3.38,0,.61-2s1.23,0,2.11,0c.56,0,3.58,0,4.52-.61.61-.37.33-1.05-.07-1.63A3.33,3.33,0,0,0,90,374.46c-.84,0-3.48.28-4.06.35l-2,.27c-.56.08-2.33.42-2.56.49-.61.19-.8.51-.51,1.09a2,2,0,0,0,1.21,1c.48.18,1.4.39,1.4.39s-.35.94-.57,1.56c-.15.44-.34,1-.63,1.05l-.16,0c-.72.07-1.15.47-1.13,1,0,.37.29,1.49.27,1.66a1.33,1.33,0,0,1,0,.19,11.89,11.89,0,0,0-.81,2.15,4.59,4.59,0,0,0,.15,2.7,2.39,2.39,0,0,0,.16.38,4.4,4.4,0,0,0,.48.77",
  transform: "translate(0 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M97.38,390.35s-.31.88-.53,1.58c-.39,1.2-1.23,4.43-1.43,5.43-.29,1.49-1.13,5.39-1.18,5.48a.55.55,0,0,1-.24.24c-.34.2-.48.13-.9-.09a3.83,3.83,0,0,1-1.44-1.11c-.82-1.06-.62-3-.46-4.22a36.26,36.26,0,0,1,2.7-9.94.16.16,0,0,0,0-.15,8.26,8.26,0,0,1-.75-3.28c0-3.19,1.85-6.34,3.92-8.88.16-.19,1.17-1.4,1.64-1.37s.53.55.46,1a13.35,13.35,0,0,1-2,4.21,12.69,12.69,0,0,0-1.37,3.24,11.49,11.49,0,0,0-.21,1.24c0,.34.09.77.09.77s1.31-1.81,2.17-2.93c.47-.61.81-1,1.2-1.46s1.93-2,2.37-2.44a8.67,8.67,0,0,1,2.34-1.75,2.06,2.06,0,0,1,2.28,0,5.25,5.25,0,0,1,1.9,3.86,9.25,9.25,0,0,1-.9,4.89,10.22,10.22,0,0,1-3.66,3.93,9.79,9.79,0,0,1-5.45,1.77l-.55,0m7.63-11.7a20.28,20.28,0,0,0-2.8,3.28c-.78,1.12-1.53,2.4-2.24,3.4a8.36,8.36,0,0,0-.6,1,2.3,2.3,0,0,0,1,0,8.14,8.14,0,0,0,3.12-1.45,6.59,6.59,0,0,0,2.27-3.55,3.71,3.71,0,0,0-.22-2.62.35.35,0,0,0-.5-.06",
  transform: "translate(0 5.28)"
})));

var SvgDisney = function SvgDisney(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 857.51 408.48",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDisney, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/disney.583cb21d.svg";
export { ForwardRef as ReactComponent };